//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
      this.http = http ? http : window as any;
      this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param routingNumberSearch (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getAllBankLookup(v: string, routingNumberSearch?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<BankModelReponse[]> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/banks/lookup?";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (routingNumberSearch !== undefined && routingNumberSearch !== null)
          url_ += "RoutingNumberSearch=" + encodeURIComponent("" + routingNumberSearch) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetAllBankLookup(_response);
      });
  }

  protected processGetAllBankLookup(response: Response): Promise<BankModelReponse[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankModelReponse[];
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<BankModelReponse[]>(null as any);
  }

  /**
   * @param pageIndex (optional) 
   * @param pageSize (optional) 
   * @param sortColumn (optional) 
   * @param sortAscending (optional) 
   * @param fullTextFilter (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getAllBankAccount(v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<BankAccountSearchResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/bankaccounts?";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (pageIndex === null)
          throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
          url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
          throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
          url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
          url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
          throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
          url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
          url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetAllBankAccount(_response);
      });
  }

  protected processGetAllBankAccount(response: Response): Promise<BankAccountSearchResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankAccountSearchResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<BankAccountSearchResponse>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getBankAccountByAgentId(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<BankAccountResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/bankaccounts/bankaccountforagent/{agentId}";
      if (agentId === undefined || agentId === null)
          throw new Error("The parameter 'agentId' must be defined.");
      url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetBankAccountByAgentId(_response);
      });
  }

  protected processGetBankAccountByAgentId(response: Response): Promise<BankAccountResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankAccountResponse;
          return result200;
          });
      } else if (status === 404) {
          return response.text().then((_responseText) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Not Found", status, _responseText, _headers, result404);
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else {
          return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Error", status, _responseText, _headers, resultdefault);
          });
      }
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getBankAccountTypes(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<BankAccountResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/bankaccounts/bankaccounttypes";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetBankAccountTypes(_response);
      });
  }

  protected processGetBankAccountTypes(response: Response): Promise<BankAccountResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankAccountResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<BankAccountResponse>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getBankAccountPaymentMethods(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<BankAccountResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/bankaccounts/bankaccountpaymentmethods";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetBankAccountPaymentMethods(_response);
      });
  }

  protected processGetBankAccountPaymentMethods(response: Response): Promise<BankAccountResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankAccountResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<BankAccountResponse>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  updateBankAccount(agentid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: BankAccountDetailModel | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/bankaccounts/{agentid}";
      if (agentid === undefined || agentid === null)
          throw new Error("The parameter 'agentid' must be defined.");
      url_ = url_.replace("{agentid}", encodeURIComponent("" + agentid));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processUpdateBankAccount(_response);
      });
  }

  protected processUpdateBankAccount(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @param companyId (optional) 
   * @param fromDate (optional) 
   * @param toDate (optional) 
   * @param paidDivisionId (optional) 
   * @param pageIndex (optional) 
   * @param pageSize (optional) 
   * @param sortColumn (optional) 
   * @param sortAscending (optional) 
   * @param fullTextFilter (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getAllBankDeposit(v: string, companyId?: number | null | undefined, fromDate?: Date | null | undefined, toDate?: Date | null | undefined, paidDivisionId?: number | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<BankDepositSearchResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/bankdeposits?";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (companyId !== undefined && companyId !== null)
          url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (fromDate !== undefined && fromDate !== null)
          url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
      if (toDate !== undefined && toDate !== null)
          url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
      if (paidDivisionId !== undefined && paidDivisionId !== null)
          url_ += "PaidDivisionId=" + encodeURIComponent("" + paidDivisionId) + "&";
      if (pageIndex === null)
          throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
          url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
          throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
          url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
          url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
          throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
          url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
          url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetAllBankDeposit(_response);
      });
  }

  protected processGetAllBankDeposit(response: Response): Promise<BankDepositSearchResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankDepositSearchResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<BankDepositSearchResponse>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  createBankDeposit(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateCarrierBankDepositModel | undefined): Promise<number> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/bankdeposits";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processCreateBankDeposit(_response);
      });
  }

  protected processCreateBankDeposit(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 201) {
          return response.text().then((_responseText) => {
          let result201: any = null;
          result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
          return result201;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  updateBankDeposit(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: UpdateCarrierBankDepositModel | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/bankdeposits";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "PUT",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processUpdateBankDeposit(_response);
      });
  }

  protected processUpdateBankDeposit(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getBankDepositId(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CarrierBankDepositModel> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/bankdeposits/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetBankDepositId(_response);
      });
  }

  protected processGetBankDepositId(response: Response): Promise<CarrierBankDepositModel> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CarrierBankDepositModel;
          return result200;
          });
      } else if (status === 404) {
          return response.text().then((_responseText) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Not Found", status, _responseText, _headers, result404);
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else {
          return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Error", status, _responseText, _headers, resultdefault);
          });
      }
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  deleteBankDeposit(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/bankdeposits/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "DELETE",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processDeleteBankDeposit(_response);
      });
  }

  protected processDeleteBankDeposit(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getAllBankAccountsLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/bankdeposits/bankaccountlookup";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetAllBankAccountsLookup(_response);
      });
  }

  protected processGetAllBankAccountsLookup(response: Response): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ListItem[]>(null as any);
  }

  /**
   * @param agentId (optional) 
   * @param pageIndex (optional) 
   * @param pageSize (optional) 
   * @param sortColumn (optional) 
   * @param sortAscending (optional) 
   * @param fullTextFilter (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getAllCreditCard(v: string, agentId?: number | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CreditCardChargeResponseModel> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/creditcards?";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (agentId !== undefined && agentId !== null)
          url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
      if (pageIndex === null)
          throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
          url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
          throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
          url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
          url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
          throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
          url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
          url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetAllCreditCard(_response);
      });
  }

  protected processGetAllCreditCard(response: Response): Promise<CreditCardChargeResponseModel> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreditCardChargeResponseModel;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<CreditCardChargeResponseModel>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  createCreditCard(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateCreditCardChargeModel | undefined): Promise<number> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/creditcards";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processCreateCreditCard(_response);
      });
  }

  protected processCreateCreditCard(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 201) {
          return response.text().then((_responseText) => {
          let result201: any = null;
          result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
          return result201;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  updateCreditCard(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: UpdateCreditCardChargeModel | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/creditcards";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "PUT",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processUpdateCreditCard(_response);
      });
  }

  protected processUpdateCreditCard(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getCreditCardById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CreditCardChargeModel2> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/creditcards/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetCreditCardById(_response);
      });
  }

  protected processGetCreditCardById(response: Response): Promise<CreditCardChargeModel2> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreditCardChargeModel2;
          return result200;
          });
      } else if (status === 404) {
          return response.text().then((_responseText) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Not Found", status, _responseText, _headers, result404);
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else {
          return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Error", status, _responseText, _headers, resultdefault);
          });
      }
  }

  /**
   * @param agentId (optional) 
   * @param pageIndex (optional) 
   * @param pageSize (optional) 
   * @param sortColumn (optional) 
   * @param sortAscending (optional) 
   * @param fullTextFilter (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getAllCreditCheck(v: string, agentId?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CreditCheckAgentByIdResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/creditcheck?";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (agentId === null)
          throw new Error("The parameter 'agentId' cannot be null.");
      else if (agentId !== undefined)
          url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
      if (pageIndex === null)
          throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
          url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
          throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
          url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
          url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
          throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
          url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
          url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetAllCreditCheck(_response);
      });
  }

  protected processGetAllCreditCheck(response: Response): Promise<CreditCheckAgentByIdResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreditCheckAgentByIdResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<CreditCheckAgentByIdResponse>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  createCreditCheck(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateCreditCheckModel | undefined): Promise<number> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/creditcheck";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processCreateCreditCheck(_response);
      });
  }

  protected processCreateCreditCheck(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 201) {
          return response.text().then((_responseText) => {
          let result201: any = null;
          result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
          return result201;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  updateCreditCheck(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateCreditCheckModel | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/creditcheck";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "PUT",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processUpdateCreditCheck(_response);
      });
  }

  protected processUpdateCreditCheck(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @param agentId (optional) 
   * @param pageIndex (optional) 
   * @param pageSize (optional) 
   * @param sortColumn (optional) 
   * @param sortAscending (optional) 
   * @param fullTextFilter (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getCreditCheckHistory(v: string, agentId?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CreditCheckHistoryResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/creditcheck/creditcheckhistory?";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (agentId === null)
          throw new Error("The parameter 'agentId' cannot be null.");
      else if (agentId !== undefined)
          url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
      if (pageIndex === null)
          throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
          url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
          throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
          url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
          url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
          throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
          url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
          url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetCreditCheckHistory(_response);
      });
  }

  protected processGetCreditCheckHistory(response: Response): Promise<CreditCheckHistoryResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreditCheckHistoryResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<CreditCheckHistoryResponse>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getCreditCheckById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CreditCardCheckResponseModel> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/creditcheck/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetCreditCheckById(_response);
      });
  }

  protected processGetCreditCheckById(response: Response): Promise<CreditCardCheckResponseModel> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreditCardCheckResponseModel;
          return result200;
          });
      } else if (status === 404) {
          return response.text().then((_responseText) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Not Found", status, _responseText, _headers, result404);
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else {
          return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Error", status, _responseText, _headers, resultdefault);
          });
      }
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  deleteCreditCheck(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/creditcheck/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "DELETE",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processDeleteCreditCheck(_response);
      });
  }

  protected processDeleteCreditCheck(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getCreditCheckVendor(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/creditcheck/creditcheckvendor";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetCreditCheckVendor(_response);
      });
  }

  protected processGetCreditCheckVendor(response: Response): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ListItem[]>(null as any);
  }

  /**
   * @param carrierId (optional) 
   * @param pageIndex (optional) 
   * @param pageSize (optional) 
   * @param sortColumn (optional) 
   * @param sortAscending (optional) 
   * @param fullTextFilter (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getAllDebt(agentid: number, v: string, carrierId?: number | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DebtQueryResponseModel> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/debts/{agentid}?";
      if (agentid === undefined || agentid === null)
          throw new Error("The parameter 'agentid' must be defined.");
      url_ = url_.replace("{agentid}", encodeURIComponent("" + agentid));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (carrierId !== undefined && carrierId !== null)
          url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
      if (pageIndex === null)
          throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
          url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
          throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
          url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
          url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
          throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
          url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
          url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetAllDebt(_response);
      });
  }

  protected processGetAllDebt(response: Response): Promise<DebtQueryResponseModel> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DebtQueryResponseModel;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<DebtQueryResponseModel>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getDebtById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DebtGetByIdModel> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/debts/{id}/debt";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetDebtById(_response);
      });
  }

  protected processGetDebtById(response: Response): Promise<DebtGetByIdModel> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DebtGetByIdModel;
          return result200;
          });
      } else if (status === 404) {
          return response.text().then((_responseText) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Not Found", status, _responseText, _headers, result404);
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else {
          return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Error", status, _responseText, _headers, resultdefault);
          });
      }
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getAgentDebtLevel(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/debts/agentdebtlevel";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetAgentDebtLevel(_response);
      });
  }

  protected processGetAgentDebtLevel(response: Response): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ListItem[]>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  createDebt(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateDebtModel | undefined): Promise<number> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/debts";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processCreateDebt(_response);
      });
  }

  protected processCreateDebt(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 201) {
          return response.text().then((_responseText) => {
          let result201: any = null;
          result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
          return result201;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  updateDebt(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateDebtModel | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/debts";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "PUT",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processUpdateDebt(_response);
      });
  }

  protected processUpdateDebt(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  deleteDebt(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/debts/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "DELETE",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processDeleteDebt(_response);
      });
  }

  protected processDeleteDebt(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  agentDebtImportlDropDownValues(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentDebtImportDropDownValuesResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/importagentdebt/AgentDebtImportlDropDownValues";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processAgentDebtImportlDropDownValues(_response);
      });
  }

  protected processAgentDebtImportlDropDownValues(response: Response): Promise<AgentDebtImportDropDownValuesResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentDebtImportDropDownValuesResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<AgentDebtImportDropDownValuesResponse>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param reportDate (optional) 
   * @param agentDebtImportId (optional) 
   * @param file (optional) 
   * @return Success
   */
  agentDebtImport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, reportDate?: Date | undefined, agentDebtImportId?: number | undefined, file?: FileParameter | null | undefined): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/importagentdebt/AgentDebtImport";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = new FormData();
      if (reportDate === null || reportDate === undefined)
          throw new Error("The parameter 'reportDate' cannot be null.");
      else
          content_.append("ReportDate", reportDate.toJSON());
      if (agentDebtImportId === null || agentDebtImportId === undefined)
          throw new Error("The parameter 'agentDebtImportId' cannot be null.");
      else
          content_.append("AgentDebtImportId", agentDebtImportId.toString());
      if (file !== null && file !== undefined)
          content_.append("File", file.data, file.fileName ? file.fileName : "File");

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processAgentDebtImport(_response);
      });
  }

  protected processAgentDebtImport(response: Response): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 201) {
          return response.text().then((_responseText) => {
          let result201: any = null;
          result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
          return result201;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ReportFile>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  journalReportDropDownValues(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<JournalReportDropDownValuesResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/journalreport/JournalReportDropDownValues";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processJournalReportDropDownValues(_response);
      });
  }

  protected processJournalReportDropDownValues(response: Response): Promise<JournalReportDropDownValuesResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JournalReportDropDownValuesResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<JournalReportDropDownValuesResponse>(null as any);
  }

  /**
   * @param divisionId (optional) 
   * @param year (optional) 
   * @param agentValueTypeId (optional) 
   * @param date (optional) 
   * @param startDate (optional) 
   * @param endDate (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  dropDownValuesChanged(v: string, divisionId?: number | null | undefined, year?: number | null | undefined, agentValueTypeId?: number | null | undefined, date?: Date | undefined, startDate?: Date | undefined, endDate?: Date | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DropDownValuesChangedResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/journalreport?";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (divisionId !== undefined && divisionId !== null)
          url_ += "DivisionId=" + encodeURIComponent("" + divisionId) + "&";
      if (year !== undefined && year !== null)
          url_ += "Year=" + encodeURIComponent("" + year) + "&";
      if (agentValueTypeId !== undefined && agentValueTypeId !== null)
          url_ += "AgentValueTypeId=" + encodeURIComponent("" + agentValueTypeId) + "&";
      if (date === null)
          throw new Error("The parameter 'date' cannot be null.");
      else if (date !== undefined)
          url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
      if (startDate === null)
          throw new Error("The parameter 'startDate' cannot be null.");
      else if (startDate !== undefined)
          url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
      if (endDate === null)
          throw new Error("The parameter 'endDate' cannot be null.");
      else if (endDate !== undefined)
          url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processDropDownValuesChanged(_response);
      });
  }

  protected processDropDownValuesChanged(response: Response): Promise<DropDownValuesChangedResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DropDownValuesChangedResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<DropDownValuesChangedResponse>(null as any);
  }

  /**
   * @param divisionId (optional) 
   * @param year (optional) 
   * @param agentValueTypeId (optional) 
   * @param date (optional) 
   * @param agentTypeText (optional) 
   * @param startDate (optional) 
   * @param endDate (optional) 
   * @param pageIndex (optional) 
   * @param pageSize (optional) 
   * @param sortColumn (optional) 
   * @param sortAscending (optional) 
   * @param fullTextFilter (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  downloadAllJournalReport(v: string, divisionId?: number | null | undefined, year?: number | null | undefined, agentValueTypeId?: number | null | undefined, date?: Date | undefined, agentTypeText?: string | null | undefined, startDate?: Date | undefined, endDate?: Date | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/journalreport/agents/download?";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (divisionId !== undefined && divisionId !== null)
          url_ += "DivisionId=" + encodeURIComponent("" + divisionId) + "&";
      if (year !== undefined && year !== null)
          url_ += "Year=" + encodeURIComponent("" + year) + "&";
      if (agentValueTypeId !== undefined && agentValueTypeId !== null)
          url_ += "AgentValueTypeId=" + encodeURIComponent("" + agentValueTypeId) + "&";
      if (date === null)
          throw new Error("The parameter 'date' cannot be null.");
      else if (date !== undefined)
          url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
      if (agentTypeText !== undefined && agentTypeText !== null)
          url_ += "AgentTypeText=" + encodeURIComponent("" + agentTypeText) + "&";
      if (startDate === null)
          throw new Error("The parameter 'startDate' cannot be null.");
      else if (startDate !== undefined)
          url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
      if (endDate === null)
          throw new Error("The parameter 'endDate' cannot be null.");
      else if (endDate !== undefined)
          url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
      if (pageIndex === null)
          throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
          url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
          throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
          url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
          url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
          throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
          url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
          url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processDownloadAllJournalReport(_response);
      });
  }

  protected processDownloadAllJournalReport(response: Response): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ReportFile>(null as any);
  }

  /**
   * @param pageIndex (optional) 
   * @param pageSize (optional) 
   * @param sortColumn (optional) 
   * @param sortAscending (optional) 
   * @param fullTextFilter (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getAllAgentDeptImports(v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ManageAgentDeptResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/manageagentdebtimport?";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (pageIndex === null)
          throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
          url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
          throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
          url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
          url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
          throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
          url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
          url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetAllAgentDeptImports(_response);
      });
  }

  protected processGetAllAgentDeptImports(response: Response): Promise<ManageAgentDeptResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ManageAgentDeptResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ManageAgentDeptResponse>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  createAgentDeptImports(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateManageAgentDeptRequest | undefined): Promise<number> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/manageagentdebtimport";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processCreateAgentDeptImports(_response);
      });
  }

  protected processCreateAgentDeptImports(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 201) {
          return response.text().then((_responseText) => {
          let result201: any = null;
          result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
          return result201;
          });
      } else if (status === 400) {
          return response.text().then((_responseText) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Bad Request", status, _responseText, _headers, result400);
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else {
          return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Error", status, _responseText, _headers, resultdefault);
          });
      }
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  updateAgentDeptImports(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateManageAgentDeptRequest | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/manageagentdebtimport";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "PUT",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processUpdateAgentDeptImports(_response);
      });
  }

  protected processUpdateAgentDeptImports(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getAgentDeptImportsById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ManageAgentDeptByIdResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/manageagentdebtimport/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetAgentDeptImportsById(_response);
      });
  }

  protected processGetAgentDeptImportsById(response: Response): Promise<ManageAgentDeptByIdResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ManageAgentDeptByIdResponse;
          return result200;
          });
      } else if (status === 404) {
          return response.text().then((_responseText) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Not Found", status, _responseText, _headers, result404);
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else {
          return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Error", status, _responseText, _headers, resultdefault);
          });
      }
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  deleteAgentDeptImport(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/manageagentdebtimport/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "DELETE",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processDeleteAgentDeptImport(_response);
      });
  }

  protected processDeleteAgentDeptImport(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @param status (optional) 
   * @param contractId (optional) 
   * @param companyId (optional) 
   * @param pageIndex (optional) 
   * @param pageSize (optional) 
   * @param sortColumn (optional) 
   * @param sortAscending (optional) 
   * @param fullTextFilter (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getAllPaymentPlan(agentId: number, v: string, status?: string | null | undefined, contractId?: number | undefined, companyId?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PaymentPlanResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/agents/{agentId}?";
      if (agentId === undefined || agentId === null)
          throw new Error("The parameter 'agentId' must be defined.");
      url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (status !== undefined && status !== null)
          url_ += "Status=" + encodeURIComponent("" + status) + "&";
      if (contractId === null)
          throw new Error("The parameter 'contractId' cannot be null.");
      else if (contractId !== undefined)
          url_ += "ContractId=" + encodeURIComponent("" + contractId) + "&";
      if (companyId === null)
          throw new Error("The parameter 'companyId' cannot be null.");
      else if (companyId !== undefined)
          url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (pageIndex === null)
          throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
          url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
          throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
          url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
          url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
          throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
          url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
          url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetAllPaymentPlan(_response);
      });
  }

  protected processGetAllPaymentPlan(response: Response): Promise<PaymentPlanResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentPlanResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PaymentPlanResponse>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getPaymentPlanById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentProfileRequest> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetPaymentPlanById(_response);
      });
  }

  protected processGetPaymentPlanById(response: Response): Promise<AgentProfileRequest> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentProfileRequest;
          return result200;
          });
      } else if (status === 404) {
          return response.text().then((_responseText) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Not Found", status, _responseText, _headers, result404);
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else {
          return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Error", status, _responseText, _headers, resultdefault);
          });
      }
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  deletePaymentPlan(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DeleteResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "DELETE",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processDeletePaymentPlan(_response);
      });
  }

  protected processDeletePaymentPlan(response: Response): Promise<DeleteResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeleteResponse;
          return result200;
          });
      } else if (status === 404) {
          return response.text().then((_responseText) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Not Found", status, _responseText, _headers, result404);
          });
      } else if (status === 400) {
          return response.text().then((_responseText) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Bad Request", status, _responseText, _headers, result400);
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else {
          return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Error", status, _responseText, _headers, resultdefault);
          });
      }
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  createPaymentPlan(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdatePaymentPlanModel | undefined): Promise<number> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processCreatePaymentPlan(_response);
      });
  }

  protected processCreatePaymentPlan(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 201) {
          return response.text().then((_responseText) => {
          let result201: any = null;
          result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
          return result201;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  updatePaymentPlan(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdatePaymentPlanModel | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "PUT",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processUpdatePaymentPlan(_response);
      });
  }

  protected processUpdatePaymentPlan(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getCompanySearchLookupByAgentId(agentid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/{agentid}/companysearchlookup";
      if (agentid === undefined || agentid === null)
          throw new Error("The parameter 'agentid' must be defined.");
      url_ = url_.replace("{agentid}", encodeURIComponent("" + agentid));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetCompanySearchLookupByAgentId(_response);
      });
  }

  protected processGetCompanySearchLookupByAgentId(response: Response): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ListItem[]>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getCompanyByAgentIdForAddEditLookup(agentid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/{agentid}/companyaddeditlookup";
      if (agentid === undefined || agentid === null)
          throw new Error("The parameter 'agentid' must be defined.");
      url_ = url_.replace("{agentid}", encodeURIComponent("" + agentid));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetCompanyByAgentIdForAddEditLookup(_response);
      });
  }

  protected processGetCompanyByAgentIdForAddEditLookup(response: Response): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ListItem[]>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getProductLookupByCompanyIdAndByAgentId(agentid: number, contractid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/{agentid}/productlookup/{contractid}";
      if (agentid === undefined || agentid === null)
          throw new Error("The parameter 'agentid' must be defined.");
      url_ = url_.replace("{agentid}", encodeURIComponent("" + agentid));
      if (contractid === undefined || contractid === null)
          throw new Error("The parameter 'contractid' must be defined.");
      url_ = url_.replace("{contractid}", encodeURIComponent("" + contractid));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetProductLookupByCompanyIdAndByAgentId(_response);
      });
  }

  protected processGetProductLookupByCompanyIdAndByAgentId(response: Response): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ListItem[]>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getLevelLookupByProductIdAndAgentId(agentid: number, productid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/{agentid}/levellookup/{productid}";
      if (agentid === undefined || agentid === null)
          throw new Error("The parameter 'agentid' must be defined.");
      url_ = url_.replace("{agentid}", encodeURIComponent("" + agentid));
      if (productid === undefined || productid === null)
          throw new Error("The parameter 'productid' must be defined.");
      url_ = url_.replace("{productid}", encodeURIComponent("" + productid));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetLevelLookupByProductIdAndAgentId(_response);
      });
  }

  protected processGetLevelLookupByProductIdAndAgentId(response: Response): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ListItem[]>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getLevelLookupByProductIdAndContractId(contractid: number, productid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/{contractid}/levels/{productid}";
      if (contractid === undefined || contractid === null)
          throw new Error("The parameter 'contractid' must be defined.");
      url_ = url_.replace("{contractid}", encodeURIComponent("" + contractid));
      if (productid === undefined || productid === null)
          throw new Error("The parameter 'productid' must be defined.");
      url_ = url_.replace("{productid}", encodeURIComponent("" + productid));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetLevelLookupByProductIdAndContractId(_response);
      });
  }

  protected processGetLevelLookupByProductIdAndContractId(response: Response): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ListItem[]>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getMarketerLookupByLevelId(levelid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/marketerlookup/{levelid}";
      if (levelid === undefined || levelid === null)
          throw new Error("The parameter 'levelid' must be defined.");
      url_ = url_.replace("{levelid}", encodeURIComponent("" + levelid));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetMarketerLookupByLevelId(_response);
      });
  }

  protected processGetMarketerLookupByLevelId(response: Response): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ListItem[]>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getProductDetailByLevelId(levelid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ProductDetailModel> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/productdetailbylevel/{levelid}";
      if (levelid === undefined || levelid === null)
          throw new Error("The parameter 'levelid' must be defined.");
      url_ = url_.replace("{levelid}", encodeURIComponent("" + levelid));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetProductDetailByLevelId(_response);
      });
  }

  protected processGetProductDetailByLevelId(response: Response): Promise<ProductDetailModel> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductDetailModel;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ProductDetailModel>(null as any);
  }

  /**
   * @param companyId (optional) 
   * @param levelId (optional) 
   * @param status (optional) 
   * @param chkShowAllCommPlan (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getCommPlanLookup(id: number, v: string, companyId?: number | undefined, levelId?: number | undefined, status?: number | undefined, chkShowAllCommPlan?: boolean | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/commplanlookup/{id}?";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (companyId === null)
          throw new Error("The parameter 'companyId' cannot be null.");
      else if (companyId !== undefined)
          url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (levelId === null)
          throw new Error("The parameter 'levelId' cannot be null.");
      else if (levelId !== undefined)
          url_ += "LevelId=" + encodeURIComponent("" + levelId) + "&";
      if (status === null)
          throw new Error("The parameter 'status' cannot be null.");
      else if (status !== undefined)
          url_ += "Status=" + encodeURIComponent("" + status) + "&";
      if (chkShowAllCommPlan === null)
          throw new Error("The parameter 'chkShowAllCommPlan' cannot be null.");
      else if (chkShowAllCommPlan !== undefined)
          url_ += "ChkShowAllCommPlan=" + encodeURIComponent("" + chkShowAllCommPlan) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetCommPlanLookup(_response);
      });
  }

  protected processGetCommPlanLookup(response: Response): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ListItem[]>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getPaymentSourceLookup(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/paymentsourcelookup/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetPaymentSourceLookup(_response);
      });
  }

  protected processGetPaymentSourceLookup(response: Response): Promise<ListItem[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
          return result200;
          });
      } else if (status === 404) {
          return response.text().then((_responseText) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Not Found", status, _responseText, _headers, result404);
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else {
          return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Error", status, _responseText, _headers, resultdefault);
          });
      }
  }

  /**
   * @param levelSelectedValue (optional) 
   * @param firstYearSelectedValue (optional) 
   * @param marketerSelectedValue (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getPayFirstYearTo(levelid: number, agentid: number, v: string, levelSelectedValue?: number | undefined, firstYearSelectedValue?: number | undefined, marketerSelectedValue?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<FirstToYearResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/{agentid}/payfirstyearto/{levelid}?";
      if (levelid === undefined || levelid === null)
          throw new Error("The parameter 'levelid' must be defined.");
      url_ = url_.replace("{levelid}", encodeURIComponent("" + levelid));
      if (agentid === undefined || agentid === null)
          throw new Error("The parameter 'agentid' must be defined.");
      url_ = url_.replace("{agentid}", encodeURIComponent("" + agentid));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (levelSelectedValue === null)
          throw new Error("The parameter 'levelSelectedValue' cannot be null.");
      else if (levelSelectedValue !== undefined)
          url_ += "LevelSelectedValue=" + encodeURIComponent("" + levelSelectedValue) + "&";
      if (firstYearSelectedValue === null)
          throw new Error("The parameter 'firstYearSelectedValue' cannot be null.");
      else if (firstYearSelectedValue !== undefined)
          url_ += "FirstYearSelectedValue=" + encodeURIComponent("" + firstYearSelectedValue) + "&";
      if (marketerSelectedValue === null)
          throw new Error("The parameter 'marketerSelectedValue' cannot be null.");
      else if (marketerSelectedValue !== undefined)
          url_ += "MarketerSelectedValue=" + encodeURIComponent("" + marketerSelectedValue) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetPayFirstYearTo(_response);
      });
  }

  protected processGetPayFirstYearTo(response: Response): Promise<FirstToYearResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FirstToYearResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FirstToYearResponse>(null as any);
  }

  /**
   * @param profileId (optional) 
   * @param fileType (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getPaymentPlanReport(v: string, profileId?: number | undefined, fileType?: FileType2 | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/paymentplanreport?";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (profileId === null)
          throw new Error("The parameter 'profileId' cannot be null.");
      else if (profileId !== undefined)
          url_ += "ProfileId=" + encodeURIComponent("" + profileId) + "&";
      if (fileType === null)
          throw new Error("The parameter 'fileType' cannot be null.");
      else if (fileType !== undefined)
          url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetPaymentPlanReport(_response);
      });
  }

  protected processGetPaymentPlanReport(response: Response): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ReportFile>(null as any);
  }

  /**
   * @param profileId (optional) 
   * @param pageIndex (optional) 
   * @param pageSize (optional) 
   * @param sortColumn (optional) 
   * @param sortAscending (optional) 
   * @param fullTextFilter (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getPaymentPlanUsage(v: string, profileId?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PaymentPlanUsageResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/paymentplanusage?";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (profileId === null)
          throw new Error("The parameter 'profileId' cannot be null.");
      else if (profileId !== undefined)
          url_ += "ProfileId=" + encodeURIComponent("" + profileId) + "&";
      if (pageIndex === null)
          throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
          url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
          throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
          url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
          url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
          throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
          url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
          url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetPaymentPlanUsage(_response);
      });
  }

  protected processGetPaymentPlanUsage(response: Response): Promise<PaymentPlanUsageResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentPlanUsageResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PaymentPlanUsageResponse>(null as any);
  }

  /**
   * @param agentId (optional) 
   * @param companyId (optional) 
   * @param levelId (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getPaymentPlanScreenLookups(v: string, agentId?: number | undefined, companyId?: number | undefined, levelId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PaymentPlanScreenLookupsResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/paymentplanscreenlookups?";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (agentId === null)
          throw new Error("The parameter 'agentId' cannot be null.");
      else if (agentId !== undefined)
          url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
      if (companyId === null)
          throw new Error("The parameter 'companyId' cannot be null.");
      else if (companyId !== undefined)
          url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (levelId === null)
          throw new Error("The parameter 'levelId' cannot be null.");
      else if (levelId !== undefined)
          url_ += "LevelId=" + encodeURIComponent("" + levelId) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetPaymentPlanScreenLookups(_response);
      });
  }

  protected processGetPaymentPlanScreenLookups(response: Response): Promise<PaymentPlanScreenLookupsResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentPlanScreenLookupsResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PaymentPlanScreenLookupsResponse>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getSpecialInstructionsByLevelId(levelid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<LevelDetailModel> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/specialinstructions/{levelid}";
      if (levelid === undefined || levelid === null)
          throw new Error("The parameter 'levelid' must be defined.");
      url_ = url_.replace("{levelid}", encodeURIComponent("" + levelid));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetSpecialInstructionsByLevelId(_response);
      });
  }

  protected processGetSpecialInstructionsByLevelId(response: Response): Promise<LevelDetailModel> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LevelDetailModel;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<LevelDetailModel>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  getPaymentPlanLookupdetails(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: PaymentPlanLookupRequest | undefined): Promise<PaymentPlanLookupResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/paymentplanlookupdetails";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetPaymentPlanLookupdetails(_response);
      });
  }

  protected processGetPaymentPlanLookupdetails(response: Response): Promise<PaymentPlanLookupResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentPlanLookupResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PaymentPlanLookupResponse>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  addPaymentPlan(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdatePaymentPlanRequest | undefined): Promise<number> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/paymentplans/createpaymentplan";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processAddPaymentPlan(_response);
      });
  }

  protected processAddPaymentPlan(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 201) {
          return response.text().then((_responseText) => {
          let result201: any = null;
          result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
          return result201;
          });
      } else if (status === 400) {
          return response.text().then((_responseText) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Bad Request", status, _responseText, _headers, result400);
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else {
          return response.text().then((_responseText) => {
          let resultdefault: any = null;
          resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
          return throwException("Error", status, _responseText, _headers, resultdefault);
          });
      }
  }

  /**
   * @param companyId (optional) 
   * @param statusId (optional) 
   * @param typeId (optional) 
   * @param isIncludeInactiveCarrier (optional) 
   * @param pageIndex (optional) 
   * @param pageSize (optional) 
   * @param sortColumn (optional) 
   * @param sortAscending (optional) 
   * @param fullTextFilter (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getAllPayoutLevels(v: string, companyId?: number | undefined, statusId?: boolean | undefined, typeId?: number | null | undefined, isIncludeInactiveCarrier?: boolean | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PayoutLevelsSearchResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/payoutlevel?";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (companyId === null)
          throw new Error("The parameter 'companyId' cannot be null.");
      else if (companyId !== undefined)
          url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (statusId === null)
          throw new Error("The parameter 'statusId' cannot be null.");
      else if (statusId !== undefined)
          url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
      if (typeId !== undefined && typeId !== null)
          url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
      if (isIncludeInactiveCarrier === null)
          throw new Error("The parameter 'isIncludeInactiveCarrier' cannot be null.");
      else if (isIncludeInactiveCarrier !== undefined)
          url_ += "IsIncludeInactiveCarrier=" + encodeURIComponent("" + isIncludeInactiveCarrier) + "&";
      if (pageIndex === null)
          throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
          url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
          throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
          url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
          url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
          throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
          url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
          url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetAllPayoutLevels(_response);
      });
  }

  protected processGetAllPayoutLevels(response: Response): Promise<PayoutLevelsSearchResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayoutLevelsSearchResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PayoutLevelsSearchResponse>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  addPayoutLevel(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: PayoutLevelModel | undefined): Promise<number> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/payoutlevel";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processAddPayoutLevel(_response);
      });
  }

  protected processAddPayoutLevel(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 201) {
          return response.text().then((_responseText) => {
          let result201: any = null;
          result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
          return result201;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  updatePayoutLevel(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: PayoutLevelModel | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/payoutlevel";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "PUT",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processUpdatePayoutLevel(_response);
      });
  }

  protected processUpdatePayoutLevel(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  payoutLevelDropDownValues(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PayoutLevelDropDownValuesResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/payoutlevel/PayoutLevelDropDownValues";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processPayoutLevelDropDownValues(_response);
      });
  }

  protected processPayoutLevelDropDownValues(response: Response): Promise<PayoutLevelDropDownValuesResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayoutLevelDropDownValuesResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PayoutLevelDropDownValuesResponse>(null as any);
  }

  /**
   * @param companyId (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getPayoutLevelById(id: number, v: string, companyId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PayoutLevelModel> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/payoutlevel/{id}?";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (companyId === null)
          throw new Error("The parameter 'companyId' cannot be null.");
      else if (companyId !== undefined)
          url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetPayoutLevelById(_response);
      });
  }

  protected processGetPayoutLevelById(response: Response): Promise<PayoutLevelModel> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayoutLevelModel;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PayoutLevelModel>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  deletePayoutLevel(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/payoutlevel/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "DELETE",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processDeletePayoutLevel(_response);
      });
  }

  protected processDeletePayoutLevel(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @param companyId (optional) 
   * @param statusId (optional) 
   * @param pageIndex (optional) 
   * @param pageSize (optional) 
   * @param sortColumn (optional) 
   * @param sortAscending (optional) 
   * @param fullTextFilter (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getAllPayoutLevelsByCarrierId(v: string, companyId?: number | undefined, statusId?: boolean | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PayoutLevelsResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/payoutlevel/getallpayoutlevelsbycarrierid?";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (companyId === null)
          throw new Error("The parameter 'companyId' cannot be null.");
      else if (companyId !== undefined)
          url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (statusId !== undefined && statusId !== null)
          url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
      if (pageIndex === null)
          throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
          url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
          throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
          url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
          url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
          throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
          url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
          url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetAllPayoutLevelsByCarrierId(_response);
      });
  }

  protected processGetAllPayoutLevelsByCarrierId(response: Response): Promise<PayoutLevelsResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayoutLevelsResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PayoutLevelsResponse>(null as any);
  }

  /**
   * @param description (optional) 
   * @param companyId (optional) 
   * @param id (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getValidatePayoutLevelByCarrierId(v: string, description?: string | null | undefined, companyId?: number | undefined, id?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<boolean> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/payoutlevel/getvalidatepayoutlevelbycarrierid?";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (description !== undefined && description !== null)
          url_ += "Description=" + encodeURIComponent("" + description) + "&";
      if (companyId === null)
          throw new Error("The parameter 'companyId' cannot be null.");
      else if (companyId !== undefined)
          url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
      if (id === null)
          throw new Error("The parameter 'id' cannot be null.");
      else if (id !== undefined)
          url_ += "Id=" + encodeURIComponent("" + id) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetValidatePayoutLevelByCarrierId(_response);
      });
  }

  protected processGetValidatePayoutLevelByCarrierId(response: Response): Promise<boolean> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<boolean>(null as any);
  }

  /**
   * @param id (optional) 
   * @param pageIndex (optional) 
   * @param pageSize (optional) 
   * @param sortColumn (optional) 
   * @param sortAscending (optional) 
   * @param fullTextFilter (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getAllPayoutLevelDetails(v: string, id?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PayoutLevelDetailsSearchResponse> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/payoutleveldetail?";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (id === null)
          throw new Error("The parameter 'id' cannot be null.");
      else if (id !== undefined)
          url_ += "Id=" + encodeURIComponent("" + id) + "&";
      if (pageIndex === null)
          throw new Error("The parameter 'pageIndex' cannot be null.");
      else if (pageIndex !== undefined)
          url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
      if (pageSize === null)
          throw new Error("The parameter 'pageSize' cannot be null.");
      else if (pageSize !== undefined)
          url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      if (sortColumn !== undefined && sortColumn !== null)
          url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
      if (sortAscending === null)
          throw new Error("The parameter 'sortAscending' cannot be null.");
      else if (sortAscending !== undefined)
          url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
      if (fullTextFilter !== undefined && fullTextFilter !== null)
          url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetAllPayoutLevelDetails(_response);
      });
  }

  protected processGetAllPayoutLevelDetails(response: Response): Promise<PayoutLevelDetailsSearchResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayoutLevelDetailsSearchResponse;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PayoutLevelDetailsSearchResponse>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  addPayoutLevelDetail(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: PayoutLevelDetailModel | undefined): Promise<number> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/payoutleveldetail";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processAddPayoutLevelDetail(_response);
      });
  }

  protected processAddPayoutLevelDetail(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 201) {
          return response.text().then((_responseText) => {
          let result201: any = null;
          result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
          return result201;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  updatePayoutLevelDetail(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: PayoutLevelDetailModel | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/payoutleveldetail";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "PUT",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processUpdatePayoutLevelDetail(_response);
      });
  }

  protected processUpdatePayoutLevelDetail(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @param payoutLevelId (optional) 
   * @param companyId (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getPayoutLevelDetailById(id: number, v: string, payoutLevelId?: number | undefined, companyId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PayoutLevelDetailModel> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/payoutleveldetail/{id}?";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      if (payoutLevelId === null)
          throw new Error("The parameter 'payoutLevelId' cannot be null.");
      else if (payoutLevelId !== undefined)
          url_ += "payoutLevelId=" + encodeURIComponent("" + payoutLevelId) + "&";
      if (companyId === null)
          throw new Error("The parameter 'companyId' cannot be null.");
      else if (companyId !== undefined)
          url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "GET",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetPayoutLevelDetailById(_response);
      });
  }

  protected processGetPayoutLevelDetailById(response: Response): Promise<PayoutLevelDetailModel> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayoutLevelDetailModel;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PayoutLevelDetailModel>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  deletePayoutLevelDetail(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/payoutleveldetail/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "DELETE",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processDeletePayoutLevelDetail(_response);
      });
  }

  protected processDeletePayoutLevelDetail(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 204) {
          return response.text().then((_responseText) => {
          return;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<void>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  getAgentDebtReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: AgentDebtRequest | undefined): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/reports/agentdebt";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetAgentDebtReport(_response);
      });
  }

  protected processGetAgentDebtReport(response: Response): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ReportFile>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  getOnHoldAgentCommisionsReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: OnHoldAgentCommisionsRequest | undefined): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/reports/onholdagentcommissions";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetOnHoldAgentCommisionsReport(_response);
      });
  }

  protected processGetOnHoldAgentCommisionsReport(response: Response): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ReportFile>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getCommissionEmailReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/reports/commissionemail";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetCommissionEmailReport(_response);
      });
  }

  protected processGetCommissionEmailReport(response: Response): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ReportFile>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  getCommissionsReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CommissionsReportRequest | undefined): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/reports/commissionsreport";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetCommissionsReport(_response);
      });
  }

  protected processGetCommissionsReport(response: Response): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ReportFile>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  getCommissionsBreakupReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CommissionsBreakdownReportRequest | undefined): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/reports/commissionsbreakupreport";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetCommissionsBreakupReport(_response);
      });
  }

  protected processGetCommissionsBreakupReport(response: Response): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ReportFile>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getPaperStatementReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/reports/paperstatement";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      let options_: RequestInit = {
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetPaperStatementReport(_response);
      });
  }

  protected processGetPaperStatementReport(response: Response): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ReportFile>(null as any);
  }

  /**
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional) 
   * @return Success
   */
  getBankdepositReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: BankDepositReportRequest | undefined): Promise<ReportFile> {
      let url_ = this.baseUrl + "/api/accounting/v{v}/reports/bankdepositreport";
      if (v === undefined || v === null)
          throw new Error("The parameter 'v' must be defined.");
      url_ = url_.replace("{v}", encodeURIComponent("" + v));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
          body: content_,
          method: "POST",
          headers: {
              "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
              "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
              "Content-Type": "application/json",
              "Accept": "text/plain"
          }
      };

      return this.http.fetch(url_, options_).then((_response: Response) => {
          return this.processGetBankdepositReport(_response);
      });
  }

  protected processGetBankdepositReport(response: Response): Promise<ReportFile> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
          return result200;
          });
      } else if (status === 401) {
          return response.text().then((_responseText) => {
          return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
          });
      } else if (status === 403) {
          return response.text().then((_responseText) => {
          return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ReportFile>(null as any);
  }
}

export interface BankModelReponse {
  bankId?: number;
  bankName?: string | undefined;
}

export interface BankAccountListModel {
  bankAccountId?: number;
  bankAccountName?: string | undefined;
  abbreviation?: string | undefined;
}

export interface BankAccountSearchResponse {
  recordCount?: number;
  emailAllRecords?: BankAccountListModel[] | undefined;
  data?: BankAccountListModel[] | undefined;
}

export interface BankAccountResponse {
  bankAccountId?: number;
  bankId?: number | undefined;
  accountNumber?: string | undefined;
  bankAccountPaymentMethodId?: number;
  agentId?: number;
  bankName?: string | undefined;
  bankAccountTypeId?: number | undefined;
}

export interface ProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export interface BankAccountDetailModel {
  bankId?: number;
  accountNumber?: string | undefined;
  bankAccountTypeId?: number;
  bankAccountPaymentMethodId?: number;
  bankAccountId?: number;
}

export interface CarrierBankDepositModel {
  id?: number;
  companyId?: number;
  paidDivisionId?: number;
  amount?: number;
  dateCreated?: Date;
  createdByUserId?: number;
  comment?: string | undefined;
  companyName?: string | undefined;
  bankAccountName?: string | undefined;
  statementDate?: Date;
  readonly userName?: string | undefined;
}

export interface BankDepositSearchResponse {
  recordCount?: number;
  emailAllRecords?: CarrierBankDepositModel[] | undefined;
  data?: CarrierBankDepositModel[] | undefined;
}

export interface CreateCarrierBankDepositModel {
  id?: number;
  companyId?: number;
  paidDivisionId?: number;
  amount?: number;
  dateCreated?: Date;
  statementDate?: Date;
  createdByUserId?: number;
  comment?: string | undefined;
}

export interface UpdateCarrierBankDepositModel {
  id?: number;
  companyId?: number;
  paidDivisionId?: number;
  amount?: number;
  dateCreated?: Date;
  createdByUserId?: number;
  statementDate?: Date;
  comment?: string | undefined;
}

export interface ListItem {
  value?: string | undefined;
  text?: string | undefined;
  selected?: boolean;
}

export interface CreditCardChargeModel {
  agentId?: number;
  agentName?: string | undefined;
  amount?: number;
  chargeStatus?: string | undefined;
  dateCreated?: Date;
  description?: string | undefined;
  id?: number;
  requestedBy?: string | undefined;
  transactionId?: string | undefined;
  userFirstName?: string | undefined;
  userLastName?: string | undefined;
  displayDateCreated?: Date;
}

export interface CreditCardChargeResponseModel {
  recordCount?: number;
  emailAllRecords?: CreditCardChargeModel[] | undefined;
  data?: CreditCardChargeModel[] | undefined;
}

export interface CreateCreditCardChargeModel {
  id?: number;
  agentId?: number;
  amount?: number;
  description?: string | undefined;
  licenseFee?: boolean;
}

export interface UpdateCreditCardChargeModel {
  amount?: number;
  creditCardChargeStatusId?: number;
  id?: number;
  transactionId?: string | undefined;
}

export interface CreditCardChargeModel2 {
  agentId?: number;
  agentName?: string | undefined;
  amount?: number;
  chargeStatus?: string | undefined;
  creditCardChargeStatusId?: number;
  dateCreated?: Date;
  description?: string | undefined;
  id?: number;
  licensingFee?: boolean | undefined;
  requestedBy?: string | undefined;
  requestUserId?: number;
  transactionId?: string | undefined;
}

export interface CreditCheckListModel {
  id?: number;
  inquiryDate?: Date;
  result?: boolean;
  user?: string | undefined;
  vendor?: string | undefined;
  negativeRating?: boolean;
}

export interface CreditCheckAgentByIdResponse {
  recordCount?: number;
  emailAllRecords?: CreditCheckListModel[] | undefined;
  data?: CreditCheckListModel[] | undefined;
}

export interface CreateUpdateCreditCheckModel {
  id?: number;
  inquiryDate?: Date;
  result?: boolean;
  userId?: number;
  vendor?: string | undefined;
  agentId?: number;
  negativeRating?: boolean;
  creditCheckVendorId?: number;
}

export interface CreditCheckHistoryListModel {
  id?: number;
  agentName?: string | undefined;
  inquiryDate?: Date;
  userName?: string | undefined;
  creditCheckVendorID?: number;
  vendorName?: string | undefined;
  negativeRating?: boolean;
}

export interface CreditCheckHistoryResponse {
  recordCount?: number;
  emailAllRecords?: CreditCheckHistoryListModel[] | undefined;
  data?: CreditCheckHistoryListModel[] | undefined;
}

export interface CreditCardCheckResponseModel {
  id?: number;
  inquiryDate?: Date;
  result?: boolean;
  user?: string | undefined;
  vendorId?: number;
  negativeRating?: boolean;
}

export interface DebtListModel {
  id?: number;
  carrier?: string | undefined;
  carrierId?: number;
  awn?: string | undefined;
  reportDate?: Date;
  displayReportDate?: Date;
  advanced?: number;
  unSecured?: number;
  reserve?: number;
  side?: number;
  total?: number;
  rollUp?: number;
  producer?: number;
  upline?: number;
  isZeroedOut?: boolean;
}

export interface DebtQueryResponseModel {
  recordCount?: number;
  emailAllRecords?: DebtListModel[] | undefined;
  data?: DebtListModel[] | undefined;
}

export interface DebtGetByIdModel {
  id?: number;
  agentId?: number;
  carrierId?: number;
  writingNumber?: string | undefined;
  reportDate?: Date;
  advanced?: number;
  unSecured?: number;
  reserve?: number;
  side?: number;
  total?: number;
  rollUp?: number;
  producer?: number;
  upline?: number;
}

export interface CreateUpdateDebtModel {
  id?: number;
  agentId?: number;
  carrierId?: number;
  writingNumber?: string | undefined;
  reportDate?: string | undefined;
  advanced?: number;
  unSecured?: number;
  reserve?: number;
  side?: number;
  total?: number;
  rollUp?: number;
  producer?: number;
  upline?: number;
}

export interface AgentDebtImportDropDownValuesResponse {
  importFor?: ListItem[] | undefined;
}

export interface ReportFile {
  title?: string | undefined;
  data?: string | undefined;
  contentType?: string | undefined;
  fileName?: string | undefined;
}

export interface JournalReportDropDownValuesResponse {
  division?: ListItem[] | undefined;
  year?: number;
  agentValueType?: ListItem[] | undefined;
  date?: ListItem[] | undefined;
}

export interface DropDownValuesChangedResponse {
  dateVisible?: boolean;
  endDateVisible?: boolean;
  startDateVisible?: boolean;
  reportVisible?: boolean;
  agentValueTypeVisible?: boolean;
  date?: ListItem[] | undefined;
  endDate?: string | undefined;
  startDate?: string | undefined;
  lblStartDate?: string | undefined;
  lblEndDate?: string | undefined;
}

export interface ManageAgentDeptImports {
  id?: number;
  name?: string | undefined;
}

export interface ManageAgentDeptResponse {
  recordCount?: number;
  emailAllRecords?: ManageAgentDeptImports[] | undefined;
  data?: ManageAgentDeptImports[] | undefined;
}

export interface CreateManageAgentDeptRequest {
  companyId?: number;
  writingNumberColumnIndex?: number;
  advancedColumnIndex?: number | undefined;
  unsecuredColumnIndex?: number | undefined;
  reserveColumnIndex?: number | undefined;
  sideColumnIndex?: number | undefined;
  rollupColumnIndex?: number | undefined;
  producerWeekColumnIndex?: number | undefined;
  uplineWeekColumnIndex?: number | undefined;
  id?: number;
  agentDebtImportName?: string | undefined;
}

export interface ManageAgentDeptByIdResponse {
  companyId?: number;
  writingNumberColumnIndex?: number;
  advancedColumnIndex?: number | undefined;
  unsecuredColumnIndex?: number | undefined;
  reserveColumnIndex?: number | undefined;
  sideColumnIndex?: number | undefined;
  rollupColumnIndex?: number | undefined;
  producerWeekColumnIndex?: number | undefined;
  uplineWeekColumnIndex?: number | undefined;
  name?: string | undefined;
  carriers?: ListItem[] | undefined;
}

export interface PaymentPlanListModel {
  id?: number;
  companyId?: number;
  status?: string | undefined;
  licenseId?: number;
  licenseStatus?: string | undefined;
  productNumber?: string | undefined;
  agentNumber?: string | undefined;
  commPlanName?: string | undefined;
  profileStatus?: string | undefined;
  companyName?: string | undefined;
  subCategory?: string | undefined;
  description?: string | undefined;
  specialInstructions?: string | undefined;
  marketer?: string | undefined;
  subCategoryId?: number;
  productId?: number;
  marketerId?: number | undefined;
  levelId?: number;
  payoutLevelId?: number | undefined;
  profileCommPlanId?: number;
  profileIsActive?: boolean;
  profilePayToId?: number;
  profilePaymentSourceId?: number;
}

export interface PaymentPlanResponse {
  recordCount?: number;
  emailAllRecords?: PaymentPlanListModel[] | undefined;
  data?: PaymentPlanListModel[] | undefined;
}

export interface CommissionPaymentMethod {
  id?: number;
  paymentMethodName?: string | undefined;
  commPlan?: CommPlan[] | undefined;
}

export interface TblPaymentSource {
  id?: number;
  paymentSource?: string | undefined;
  commPlan?: CommPlan[] | undefined;
  profile?: Profile[] | undefined;
}

export interface RenewalAge {
  id?: number;
  planId?: number | undefined;
  age1?: number | undefined;
  age2?: number | undefined;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  plan?: CommPlan;
}

export interface CommPlan {
  id?: number;
  companyId?: number;
  name?: string | undefined;
  description?: string | undefined;
  status?: number;
  paymentSourceId?: number;
  paymentMethodId?: number;
  alwaysShow?: boolean;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  paymentMethod?: CommissionPaymentMethod;
  paymentSource?: TblPaymentSource;
  profile?: Profile[] | undefined;
  renewalAge?: RenewalAge[] | undefined;
}

export interface LongRunningMarketingEventGroup {
  id?: number;
  name?: string | undefined;
  marketingEvent?: MarketingEvent[] | undefined;
}

export interface MarketingEventType {
  id?: number;
  marketingEventTypeName?: string | undefined;
  marketingEvent?: MarketingEvent[] | undefined;
}

export interface MarketingFormat {
  id?: number;
  marketingFormatName?: string | undefined;
  marketingEvent?: MarketingEvent[] | undefined;
}

export interface EmailDomain {
  id?: number;
  domain?: string | undefined;
  isExcludedFromReports?: boolean | undefined;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  emailAddress?: EmailAddress[] | undefined;
}

export interface EmailAddress {
  id?: number;
  address?: string | undefined;
  emailDomainId?: number;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  emailDomain?: EmailDomain;
  marketingEventEmail?: MarketingEventEmail[] | undefined;
}

export interface MarketingEventEmail {
  id?: number;
  emailAddressId?: number;
  marketingEventEmailListId?: number;
  sent?: boolean | undefined;
  sentTime?: Date | undefined;
  canSend?: boolean;
  statusMessage?: string | undefined;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  emailAddress?: EmailAddress;
  marketingEventEmailList?: MarketingEventEmailList;
}

export interface MarketingEventEmailList {
  id?: number;
  dateStart?: Date;
  userId?: number;
  dateEnd?: Date;
  marketingEventId?: number;
  sent?: boolean;
  listName?: string | undefined;
  isPaused?: boolean;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  marketingEvent?: MarketingEvent;
  marketingEventEmail?: MarketingEventEmail[] | undefined;
}

export interface MarketingEvent {
  id?: number;
  marketingEventTypeId?: number;
  marketingFormatId?: number;
  ownerId?: number;
  companyId?: number;
  divisionId?: number;
  dateTimeStart?: Date;
  dateTimeEnd?: Date;
  title?: string | undefined;
  description?: string | undefined;
  url?: string | undefined;
  audience?: string | undefined;
  requestorId?: number | undefined;
  audienceSize?: number | undefined;
  purchasedLead?: boolean | undefined;
  emailSubject?: string | undefined;
  fromEmailAddress?: string | undefined;
  fromDisplayName?: string | undefined;
  replyTo?: string | undefined;
  longRunningMarketingEventGroupId?: number | undefined;
  productLineId?: number;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  longRunningMarketingEventGroup?: LongRunningMarketingEventGroup;
  marketingEventType?: MarketingEventType;
  marketingFormat?: MarketingFormat;
  calllist?: Calllist[] | undefined;
  marketingEventEmailList?: MarketingEventEmailList[] | undefined;
}

export interface Calllist {
  id?: number;
  teamId?: number;
  calllistName?: string | undefined;
  userId?: number;
  createdDate?: Date;
  prospective?: boolean;
  exist?: boolean | undefined;
  marketingEventId?: number | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  marketingEvent?: MarketingEvent;
  users?: Users[] | undefined;
}

export interface Bank {
  bankId?: number;
  routingNumber?: string | undefined;
  bankName?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  bankAccounts?: BankAccounts[] | undefined;
}

export interface BankAccountPaymentMethod {
  bankAccountPaymentMethodId?: number;
  bankAccountPaymentMethodName?: string | undefined;
  sort?: number | undefined;
  bankAccounts?: BankAccounts[] | undefined;
}

export interface BankAccountType {
  bankAccountTypeId?: number;
  bankAccountTypeName?: string | undefined;
  bankAccounts?: BankAccounts[] | undefined;
}

export interface BankAccounts {
  bankAccountId?: number;
  agentId?: number;
  bankId?: number | undefined;
  accountNumber?: string | undefined;
  description?: string | undefined;
  createdByUserId?: number;
  dateCreated?: Date;
  bankAccountTypeId?: number | undefined;
  bankAccountPaymentMethodId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  agent?: Agents;
  bank?: Bank;
  bankAccountPaymentMethod?: BankAccountPaymentMethod;
  bankAccountType?: BankAccountType;
  createdByUser?: Users;
  license?: License[] | undefined;
}

export interface PolicyRating {
  id?: number;
  rating?: string | undefined;
  isDefault?: boolean;
  policyAppliedRating?: Policy[] | undefined;
  policyApprovedRating?: Policy[] | undefined;
}

export interface AgentDebt {
  agentDebtId?: number;
  createdDateTime?: Date;
  createdByUserId?: number;
  agentId?: number;
  companyId?: number;
  reportDate?: Date;
  advanced?: number;
  unsecured?: number;
  reserve?: number;
  side?: number;
  rollup?: number;
  producerWeek?: number;
  uplineWeek?: number;
  writingNumber?: string | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  agent?: Agents;
  company?: Company;
}

export interface LicensePersistency {
  licensePersistencyId?: number;
  licenseId?: number;
  licensePersistencyTypeId?: number;
  createdDateTime?: Date;
  persistencyPercentage?: number;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  license?: License;
  licensePersistencyType?: LicensePersistencyType;
}

export interface LicensePersistencyTypeColoringRule {
  licensePersistencyTypeColoringRuleId?: number;
  licensePersistencyTypeId?: number;
  hexColor?: string | undefined;
  startRange?: number;
  stopRange?: number;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  licensePersistencyType?: LicensePersistencyType;
}

export interface LicensePersistencyType {
  licensePersistencyTypeId?: number;
  companyId?: number;
  licensePersistencyTypeName?: string | undefined;
  sortOrder?: number;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  company?: Company;
  licensePersistency?: LicensePersistency[] | undefined;
  licensePersistencyTypeColoringRule?: LicensePersistencyTypeColoringRule[] | undefined;
}

export interface SubmissionRequirementRulesetFilterCompany {
  submissionRequirementRulesetFilterCompanyId?: number;
  submissionRequirementRulesetId?: number;
  companyId?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  company?: Company;
  createdByUser?: Users;
  submissionRequirementRuleset?: SubmissionRequirementRuleset;
}

export interface SubmissionRequirementRulesetFilterPolicyEffectiveDateYear {
  submissionRequirementRulesetFilterPolicyEffectiveDateYearId?: number;
  submissionRequirementRulesetId?: number;
  policyEffectiveDateYear?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  submissionRequirementRuleset?: SubmissionRequirementRuleset;
}

export interface TblProductCategory {
  id?: number;
  productCategoryName?: string | undefined;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  tblProductSubCategory?: TblProductSubCategory[] | undefined;
}

export interface AgentProductLine {
  id?: number;
  agentId?: number;
  productLineId?: number;
  contracted?: boolean;
  active?: boolean;
  referred?: boolean;
  dateCreated?: Date;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  agent?: Agents;
  productLine?: TblProductLine;
}

export interface AgentContactEmailUnsubscribe {
  id?: number;
  emailId?: string | undefined;
  productLineID?: number;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  productLine?: TblProductLine;
}

export interface TblProductLine {
  id?: number;
  productLineName?: string | undefined;
  isMarketerHierarchyBased?: boolean;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  agentProductLine?: AgentProductLine[] | undefined;
  tblProductSubCategory?: TblProductSubCategory[] | undefined;
  agentContactEmailUnsubscribe?: AgentContactEmailUnsubscribe[] | undefined;
}

export interface SubmissionAutoUncheckRulesetFilterProductSubcategory {
  submissionAutoUncheckRulesetFilterProductSubcategoryId?: number;
  submissionAutoUncheckRulesetId?: number;
  productSubcategoryId?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  productSubcategory?: TblProductSubCategory;
  submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
}

export interface SubmissionRequirementRulesetFilterProductSubcategory {
  submissionRequirementRulesetFilterProductSubcategoryId?: number;
  submissionRequirementRulesetId?: number;
  productSubcategoryId?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  productSubcategory?: TblProductSubCategory;
  submissionRequirementRuleset?: SubmissionRequirementRuleset;
}

export interface SubmissionSenderTypeEmail {
  submissionSenderTypeEmailId?: number;
  submissionSenderTypeEmailName?: string | undefined;
  fromEmailAddress?: string | undefined;
  dateTimeCreated?: Date;
  dateTimeModified?: Date | undefined;
  createdByUserId?: number;
  modifiedByUserId?: number | undefined;
  createdByUser?: Users;
  modifiedByUser?: Users;
  submissionRulesetConnectorTypeEmail?: SubmissionRulesetConnectorTypeEmail[] | undefined;
}

export interface SubmissionTypeEmail {
  submissionTypeEmailId?: number;
  submissionTypeEmailName?: string | undefined;
  toEmailAddress?: string | undefined;
  sendAsSecureEmail?: boolean;
  isDisabled?: boolean;
  dateTimeCreated?: Date;
  dateTimeModified?: Date | undefined;
  createdByUserId?: number;
  modifiedByUserId?: number | undefined;
  createdByUser?: Users;
  modifiedByUser?: Users;
  submissionRulesetConnectorTypeEmail?: SubmissionRulesetConnectorTypeEmail[] | undefined;
}

export interface SubmissionRulesetConnectorTypeEmail {
  submissionRulesetConnectorTypeEmailId?: number;
  submissionRulesetId?: number;
  submissionTypeEmailId?: number;
  submissionSenderTypeEmailId?: number;
  fileName?: string | undefined;
  priority?: number;
  dateTimeCreated?: Date;
  dateTimeModified?: Date | undefined;
  createdByUserId?: number;
  modifiedByUserId?: number | undefined;
  createdByUser?: Users;
  modifiedByUser?: Users;
  submissionRuleset?: SubmissionRuleset;
  submissionSenderTypeEmail?: SubmissionSenderTypeEmail;
  submissionTypeEmail?: SubmissionTypeEmail;
}

export interface SubmissionTypeFtp {
  submissionTypeFtpid?: number;
  submissionTypeFtpname?: string | undefined;
  server?: string | undefined;
  userName?: string | undefined;
  password?: string | undefined;
  port?: number;
  ftptype?: number;
  isDisabled?: boolean;
  dateTimeCreated?: Date;
  dateTimeModified?: Date | undefined;
  createdByUserId?: number;
  modifiedByUserId?: number | undefined;
  createdByUser?: Users;
  modifiedByUser?: Users;
  submissionRulesetConnectorTypeFtp?: SubmissionRulesetConnectorTypeFtp[] | undefined;
}

export interface SubmissionRulesetConnectorTypeFtp {
  submissionRulesetConnectorTypeFtpid?: number;
  submissionRulesetId?: number;
  submissionTypeFtpid?: number;
  filePath?: string | undefined;
  fileName?: string | undefined;
  priority?: number;
  dateTimeCreated?: Date;
  dateTimeModified?: Date | undefined;
  createdByUserId?: number;
  modifiedByUserId?: number | undefined;
  createdByUser?: Users;
  modifiedByUser?: Users;
  submissionRuleset?: SubmissionRuleset;
  submissionTypeFtp?: SubmissionTypeFtp;
}

export interface SubmissionRulesetFilterCompany {
  submissionRulesetFilterCompanyId?: number;
  submissionRulesetId?: number;
  companyId?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  company?: Company;
  createdByUser?: Users;
  submissionRuleset?: SubmissionRuleset;
}

export interface SubmissionRulesetFilterDocumentType {
  submissionRulesetFilterDocumentTypeId?: number;
  submissionRulesetId?: number;
  documentTypeId?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  documentType?: FileType;
  submissionRuleset?: SubmissionRuleset;
}

export interface SubmissionRulesetFilterPolicyEffectiveDateYear {
  submissionRulesetFilterPolicyEffectiveDateYearId?: number;
  submissionRulesetId?: number;
  policyEffectiveDateYear?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  submissionRuleset?: SubmissionRuleset;
}

export interface SubmissionRulesetFilterProduct {
  submissionRulesetFilterProductId?: number;
  submissionRulesetId?: number;
  productId?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  product?: TblProduct;
  submissionRuleset?: SubmissionRuleset;
}

export interface OrdersDetails {
  id?: number;
  orderId?: number;
  supplyId?: number;
  qty?: number;
  qtySent?: number | undefined;
  comment?: string | undefined;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  orderDetailState?: OrderDetailState[] | undefined;
}

export interface OrderDetailState {
  orderDetailStateId?: number;
  orderDetailId?: number;
  stateId?: number;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  orderDetail?: OrdersDetails;
  state?: TblState;
}

export interface SubmissionAutoUncheckRulesetFilterState {
  submissionAutoUncheckRulesetFilterStateId?: number;
  submissionAutoUncheckRulesetId?: number;
  stateId?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  state?: TblState;
  submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
}

export interface SubmissionRequirementRulesetFilterState {
  submissionRequirementRulesetFilterStateId?: number;
  submissionRequirementRulesetId?: number;
  stateId?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  state?: TblState;
  submissionRequirementRuleset?: SubmissionRequirementRuleset;
}

export interface LicenseNumberState {
  id?: number;
  licenseNumberId?: number;
  stateId?: number;
  state?: TblState;
}

export interface LicenseStates {
  id?: number;
  licenseId?: number;
  stateId?: number;
  apptDate?: Date | undefined;
  termDate?: Date | undefined;
  dateCreated?: Date;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  license?: License;
  state?: TblState;
}

export interface TblProductType {
  id?: number;
  productType?: string | undefined;
  supplies?: Supplies[] | undefined;
}

export interface Supplies {
  id?: number;
  productTypeId?: number;
  companyId?: number;
  itemNumber?: string | undefined;
  itemDescription?: string | undefined;
  reOrderLevel?: number;
  active?: boolean | undefined;
  onOrderCount?: number;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  productType?: TblProductType;
  suppliesStates?: SuppliesStates[] | undefined;
}

export interface SuppliesStates {
  id?: number;
  stateId?: number;
  supplyId?: number;
  notes?: string | undefined;
  reOrderLevel?: number | undefined;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  state?: TblState;
  supply?: Supplies;
}

export interface TblState {
  id?: number;
  state?: string | undefined;
  stateName?: string | undefined;
  isTerritories?: boolean | undefined;
  orderDetailState?: OrderDetailState[] | undefined;
  submissionAutoUncheckRulesetFilterState?: SubmissionAutoUncheckRulesetFilterState[] | undefined;
  submissionRequirementRulesetFilterState?: SubmissionRequirementRulesetFilterState[] | undefined;
  submissionRulesetFilterState?: SubmissionRulesetFilterState[] | undefined;
  licenseNumberState?: LicenseNumberState[] | undefined;
  licenseStates?: LicenseStates[] | undefined;
  suppliesStates?: SuppliesStates[] | undefined;
}

export interface SubmissionRulesetFilterState {
  submissionRulesetFilterStateId?: number;
  submissionRulesetId?: number;
  stateId?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  state?: TblState;
  submissionRuleset?: SubmissionRuleset;
}

export interface SubmissionRuleset {
  submissionRulesetId?: number;
  submissionRulesetName?: string | undefined;
  submissionRulesetType?: number;
  priority?: number;
  dateTimeCreated?: Date;
  dateTimeModified?: Date | undefined;
  createdByUserId?: number;
  modifiedByUserId?: number | undefined;
  createdByUser?: Users;
  modifiedByUser?: Users;
  submissionRulesetConnectorTypeEmail?: SubmissionRulesetConnectorTypeEmail[] | undefined;
  submissionRulesetConnectorTypeFtp?: SubmissionRulesetConnectorTypeFtp[] | undefined;
  submissionRulesetFilterCompany?: SubmissionRulesetFilterCompany[] | undefined;
  submissionRulesetFilterDocumentType?: SubmissionRulesetFilterDocumentType[] | undefined;
  submissionRulesetFilterPolicyEffectiveDateYear?: SubmissionRulesetFilterPolicyEffectiveDateYear[] | undefined;
  submissionRulesetFilterProduct?: SubmissionRulesetFilterProduct[] | undefined;
  submissionRulesetFilterProductSubcategory?: SubmissionRulesetFilterProductSubcategory[] | undefined;
  submissionRulesetFilterState?: SubmissionRulesetFilterState[] | undefined;
}

export interface SubmissionRulesetFilterProductSubcategory {
  submissionRulesetFilterProductSubcategoryId?: number;
  submissionRulesetId?: number;
  productSubcategoryId?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  productSubcategory?: TblProductSubCategory;
  submissionRuleset?: SubmissionRuleset;
}

export interface TblProductSubCategory {
  id?: number;
  subCategoryName?: string | undefined;
  categoryId?: number;
  isProRateable?: boolean;
  isEnrollment?: boolean;
  productClass?: string | undefined;
  productTypeCode?: string | undefined;
  productLineId?: number;
  marginFactor?: number;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  category?: TblProductCategory;
  productLine?: TblProductLine;
  submissionAutoUncheckRulesetFilterProductSubcategory?: SubmissionAutoUncheckRulesetFilterProductSubcategory[] | undefined;
  submissionRequirementRulesetFilterProductSubcategory?: SubmissionRequirementRulesetFilterProductSubcategory[] | undefined;
  submissionRulesetFilterProductSubcategory?: SubmissionRulesetFilterProductSubcategory[] | undefined;
  tblProduct?: TblProduct[] | undefined;
}

export interface SubmissionAutoUncheckRulesetFilterProduct {
  submissionAutoUncheckRulesetFilterProductId?: number;
  submissionAutoUncheckRulesetId?: number;
  productId?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  product?: TblProduct;
  submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
}

export interface Certification {
  id?: number;
  agentId?: number;
  productId?: number;
  certificationDate?: Date;
  certificationYear?: number;
  override?: boolean;
  companyId?: number;
  dateCreated?: Date;
  createdByUserId?: number;
  note?: string | undefined;
  vueExportFileDateTime?: Date | undefined;
  timestamp?: string | undefined;
  recordStatus?: boolean | undefined;
  newRecord?: boolean | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  agent?: Agents;
  createdByUser?: Users;
  product?: TblProduct;
}

export interface TblProduct {
  id?: number;
  prodNum?: string | undefined;
  companyId?: number;
  product?: string | undefined;
  typeId?: number;
  age1?: number;
  level1?: number;
  age2?: number;
  level2?: number;
  age3?: number;
  level3?: number;
  age4?: number;
  level4?: number;
  age5?: number;
  level5?: number;
  age6?: number;
  level6?: number;
  age7?: number;
  level7?: number;
  age8?: number;
  level8?: number;
  age9?: number;
  level9?: number;
  age10?: number;
  level10?: number;
  policyFee?: number;
  agentFee?: number;
  rider?: boolean;
  tripCategoryId?: number;
  hidden?: boolean;
  subCategory?: string | undefined;
  payoutLevelId?: number | undefined;
  productTypeId?: number;
  productCategoryId?: number;
  defaultPremium?: number;
  defaultMode?: number;
  importDefaultPremium?: number;
  importDefaultMode?: number;
  subCategoryId?: number;
  carrierProductName?: string | undefined;
  fraudWatch?: boolean;
  divisionId?: number;
  dateCreated?: Date;
  checkForCertification?: boolean;
  checkForAppointment?: boolean;
  productClassId?: number | undefined;
  productCode?: string | undefined;
  isAppointmentAndCertificationRequired?: boolean;
  isShowPremiumInCommissionReportStatement?: boolean;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  subCategoryNavigation?: TblProductSubCategory;
  submissionAutoUncheckRulesetFilterProduct?: SubmissionAutoUncheckRulesetFilterProduct[] | undefined;
  submissionRequirementRulesetFilterProduct?: SubmissionRequirementRulesetFilterProduct[] | undefined;
  submissionRulesetFilterProduct?: SubmissionRulesetFilterProduct[] | undefined;
  certification?: Certification[] | undefined;
  tblDocument?: TblDocument[] | undefined;
  tblLevel?: TblLevel[] | undefined;
}

export interface SubmissionRequirementRulesetFilterProduct {
  submissionRequirementRulesetFilterProductId?: number;
  submissionRequirementRulesetId?: number;
  productId?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  product?: TblProduct;
  submissionRequirementRuleset?: SubmissionRequirementRuleset;
}

export interface SubmissionRequirementRuleset {
  submissionRequirementRulesetId?: number;
  submissionRequirementRulesetName?: string | undefined;
  submissionRulesetType?: number;
  dateTimeCreated?: Date;
  dateTimeModified?: Date | undefined;
  createdByUserId?: number;
  modifiedByUserId?: number | undefined;
  createdByUser?: Users;
  modifiedByUser?: Users;
  submissionRequirementRulesetFilterCompany?: SubmissionRequirementRulesetFilterCompany[] | undefined;
  submissionRequirementRulesetFilterDocumentType?: SubmissionRequirementRulesetFilterDocumentType[] | undefined;
  submissionRequirementRulesetFilterPolicyEffectiveDateYear?: SubmissionRequirementRulesetFilterPolicyEffectiveDateYear[] | undefined;
  submissionRequirementRulesetFilterProduct?: SubmissionRequirementRulesetFilterProduct[] | undefined;
  submissionRequirementRulesetFilterProductSubcategory?: SubmissionRequirementRulesetFilterProductSubcategory[] | undefined;
  submissionRequirementRulesetFilterState?: SubmissionRequirementRulesetFilterState[] | undefined;
}

export interface SubmissionRequirementRulesetFilterDocumentType {
  submissionRequirementRulesetFilterDocumentTypeId?: number;
  submissionRequirementRulesetId?: number;
  documentTypeId?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  documentType?: FileType;
  submissionRequirementRuleset?: SubmissionRequirementRuleset;
}

export interface FileType {
  id?: number;
  type?: string | undefined;
  isHierarchyRequired?: boolean;
  isInsured?: boolean;
  submissionAutoUncheckRulesetFilterDocumentType?: SubmissionAutoUncheckRulesetFilterDocumentType[] | undefined;
  submissionRequirementRulesetFilterDocumentType?: SubmissionRequirementRulesetFilterDocumentType[] | undefined;
  submissionRulesetFilterDocumentType?: SubmissionRulesetFilterDocumentType[] | undefined;
  tblDocument?: TblDocument[] | undefined;
}

export interface SubmissionAutoUncheckRulesetFilterDocumentType {
  submissionAutoUncheckRulesetFilterDocumentTypeId?: number;
  submissionAutoUncheckRulesetId?: number;
  documentTypeId?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  documentType?: FileType;
  submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
}

export interface SubmissionAutoUncheckRulesetFilterPolicyEffectiveDateYear {
  submissionAutoUncheckRulesetFilterPolicyEffectiveDateYearId?: number;
  submissionAutoUncheckRulesetId?: number;
  policyEffectiveDateYear?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
}

export interface SubmissionAutoUncheckRuleset {
  submissionAutoUncheckRulesetId?: number;
  submissionAutoUncheckRulesetName?: string | undefined;
  submissionRulesetType?: number;
  dateTimeCreated?: Date;
  dateTimeModified?: Date | undefined;
  createdByUserId?: number;
  modifiedByUserId?: number | undefined;
  createdByUser?: Users;
  modifiedByUser?: Users;
  submissionAutoUncheckRulesetFilterCompany?: SubmissionAutoUncheckRulesetFilterCompany[] | undefined;
  submissionAutoUncheckRulesetFilterDocumentType?: SubmissionAutoUncheckRulesetFilterDocumentType[] | undefined;
  submissionAutoUncheckRulesetFilterPolicyEffectiveDateYear?: SubmissionAutoUncheckRulesetFilterPolicyEffectiveDateYear[] | undefined;
  submissionAutoUncheckRulesetFilterProduct?: SubmissionAutoUncheckRulesetFilterProduct[] | undefined;
  submissionAutoUncheckRulesetFilterProductSubcategory?: SubmissionAutoUncheckRulesetFilterProductSubcategory[] | undefined;
  submissionAutoUncheckRulesetFilterState?: SubmissionAutoUncheckRulesetFilterState[] | undefined;
}

export interface SubmissionAutoUncheckRulesetFilterCompany {
  submissionAutoUncheckRulesetFilterCompanyId?: number;
  submissionAutoUncheckRulesetId?: number;
  companyId?: number;
  dateTimeCreated?: Date;
  createdByUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  company?: Company;
  createdByUser?: Users;
  submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
}

export interface AgentNoteType {
  id?: number;
  agentNoteTypeName?: string | undefined;
  agentNotes?: AgentNotes[] | undefined;
}

export interface PayoutLevelType {
  id?: number;
  type?: string | undefined;
  payoutLevel?: PayoutLevel[] | undefined;
}

export interface PayoutLevel {
  id?: number;
  companyId?: number;
  productId?: number | undefined;
  docId?: number | undefined;
  description?: string | undefined;
  internalOnly?: boolean | undefined;
  commission?: number | undefined;
  dateCreated?: Date;
  createUserId?: number;
  hidden?: boolean | undefined;
  companyRoleId?: number | undefined;
  compensationLevel?: string | undefined;
  rank?: number | undefined;
  typeId?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createUser?: Users;
  agentNotes?: AgentNotes[] | undefined;
  payoutLevelType?: PayoutLevelType;
  levels?: TblLevel[] | undefined;
}

export interface SalesType {
  salesTypeId?: number;
  salesTypeName?: string | undefined;
  agentNotes?: AgentNotes[] | undefined;
  license?: License[] | undefined;
}

export interface DepartmentOfInsuranceLicense {
  id?: number;
  agentId?: number;
  stateId?: number;
  issueDate?: Date | undefined;
  expirationDate?: Date | undefined;
  stateLicense?: string | undefined;
  residencyStatusId?: number | undefined;
  renewalDate?: Date | undefined;
  stateLicenseStatusId?: number | undefined;
  stateLicenseActionStatusId?: number | undefined;
  notes?: string | undefined;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  notificationSentDate?: Date | undefined;
  niprDateUpdated?: Date | undefined;
  notificationEmailAddress?: string | undefined;
  niprStatus?: string | undefined;
  niprUpdatedDate?: Date | undefined;
  tblDocumentMappings?: TblDocumentMapping[] | undefined;
}

export interface Tasks {
  id?: number;
  userId?: number;
  agentId?: number | undefined;
  customerId?: number | undefined;
  orderId?: number | undefined;
  taskDate?: Date | undefined;
  task?: string | undefined;
  description?: string | undefined;
  complete?: boolean;
  inComplete?: boolean;
  createdByUserId?: number;
  priority?: number | undefined;
  dateCreated?: Date;
  companyId?: number | undefined;
  dateCompleted?: Date | undefined;
  policyId?: number | undefined;
  completedByUserId?: number | undefined;
  modifyDate?: Date | undefined;
  modifiedBy?: number | undefined;
  company?: Company;
  policy?: Policy;
  tblDocumentMappings?: TblDocumentMapping[] | undefined;
  user?: Users;
  customer?: Customer;
  agent?: Agents;
}

export interface InsuredNote {
  id?: number;
  customerId?: number;
  note?: string | undefined;
  title?: string | undefined;
  createdDate?: Date;
  createdBy?: number;
  modifiedDate?: Date | undefined;
  modifiedBy?: number | undefined;
  private?: boolean;
  pinned?: boolean | undefined;
  deleted?: boolean | undefined;
  customer?: Customer;
  createdByNavigation?: Users;
  modifiedByNavigation?: Users;
  documentMappings?: TblDocumentMapping[] | undefined;
}

export interface TblDocumentMapping {
  id?: number;
  taskId?: number | undefined;
  noteId?: number | undefined;
  stateLicenseId?: number | undefined;
  documentId?: number | undefined;
  agentId?: number | undefined;
  insuredNoteId?: number | undefined;
  note?: AgentNotes;
  stateLicense?: DepartmentOfInsuranceLicense;
  task?: Tasks;
  document?: TblDocument;
  agents?: Agents;
  insuredNote?: InsuredNote;
}

export interface AgentNotes {
  id?: number;
  agentId?: number;
  user?: string | undefined;
  dateTime?: Date;
  note?: string | undefined;
  userId?: number;
  companyId?: number | undefined;
  payoutLevelId?: number | undefined;
  private?: boolean;
  ignore?: boolean;
  color?: number;
  agentNoteTypeId?: number;
  hierarchyPremierId?: number | undefined;
  transferFromOtherFmo?: boolean;
  salesTypeId?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  pinned?: boolean;
  agent?: Agents;
  agentNoteType?: AgentNoteType;
  company?: Company;
  hierarchyPremier?: Agents;
  payoutLevel?: PayoutLevel;
  salesType?: SalesType;
  userNavigation?: Users;
  title?: string | undefined;
  tblDocumentMappings?: TblDocumentMapping[] | undefined;
}

export interface Appointment {
  id?: number;
  agentId?: number;
  companyId?: number;
  effectiveDate?: Date;
  state?: string | undefined;
  appointmentNote?: string | undefined;
  recordStatus?: boolean | undefined;
  newRecord?: boolean | undefined;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  agent?: Agents;
  company?: Company;
}

export interface EmailType {
  id?: number;
  type?: string | undefined;
  companyContact?: CompanyContact[] | undefined;
  agentContact?: AgentContact[] | undefined;
  insuredContact?: InsuredContact[] | undefined;
}

export interface InsuredContact {
  id?: number;
  insuredId?: number;
  contactTypeId?: number;
  contactValue?: string | undefined;
  description?: string | undefined;
  createdByUserId?: number;
  dateCreated?: Date;
  default?: boolean;
  enableSMS?: boolean;
  phoneTypeId?: number | undefined;
  emailTypeId?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  insured?: Customer;
  contactType?: ContactType;
  phoneType?: PhoneType;
  createdByUser?: Users;
  emailType?: EmailType;
}

export interface PhoneType {
  id?: number;
  phoneTypeName?: string | undefined;
  sortOrder?: number;
  agentContact?: AgentContact[] | undefined;
  insuredContact?: InsuredContact[] | undefined;
  companyContact?: CompanyContact[] | undefined;
}

export interface AlternativePointOfContactType {
  id?: number;
  type?: string | undefined;
  companyContact?: CompanyContact[] | undefined;
  agentContact?: AgentContact[] | undefined;
}

export interface AgentContact {
  id?: number;
  agentId?: number;
  contactTypeId?: number;
  contactValue?: string | undefined;
  description?: string | undefined;
  createdByUserId?: number;
  dateCreated?: Date;
  default?: boolean;
  enableSMS?: boolean;
  phoneTypeId?: number | undefined;
  emailTypeId?: number | undefined;
  alternativePointOfContactTypeId?: number | undefined;
  isPhoneUnsubscribed?: boolean | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  agent?: Agents;
  contactType?: ContactType;
  phoneType?: PhoneType;
  createdByUser?: Users;
  alternativePointOfContactType?: AlternativePointOfContactType;
  emailType?: EmailType;
}

export interface ContactType {
  id?: number;
  contactTypeName?: string | undefined;
  isHidden?: boolean;
  isHiddenForInsured?: boolean;
  agentContact?: AgentContact[] | undefined;
  insuredContact?: InsuredContact[] | undefined;
  companyContact?: CompanyContact[] | undefined;
}

export interface CompanyContact {
  id?: number;
  companyId?: number;
  contactTypeId?: number;
  contactValue?: string | undefined;
  notes?: string | undefined;
  createdByUserId?: number;
  dateCreated?: Date;
  phoneTypeId?: number | undefined;
  emailTypeId?: number | undefined;
  alternativePointOfContactTypeId?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  company?: Company;
  contactType?: ContactType;
  createdByUser?: Users;
  emailType?: EmailType;
  phoneType?: PhoneType;
  alternativePointOfContactType?: AlternativePointOfContactType;
}

export interface AgentToAddress {
  agentId?: number;
  addressId?: number;
  address?: Addresses;
  agent?: Agents;
}

export interface ShippingMethod {
  id?: number;
  method?: string | undefined;
  orders?: Orders[] | undefined;
}

export interface Orders {
  id?: number;
  agentId?: number;
  userId?: number;
  shippingMethodId?: number | undefined;
  orderTakenByUserId?: number;
  orderDate?: Date;
  comments?: string | undefined;
  completed?: boolean;
  addressId?: number;
  completedDate?: Date | undefined;
  trackingNumber?: string | undefined;
  weight?: number | undefined;
  shippingDate?: Date | undefined;
  fee?: number | undefined;
  departmentId?: number | undefined;
  printedDate?: Date | undefined;
  divisionId?: number;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  address?: Addresses;
  division?: Division;
  orderTakenByUser?: Users;
  shippingMethod?: ShippingMethod;
}

export interface Addresses {
  id?: number;
  addressName?: string | undefined;
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  lastLine?: string | undefined;
  zipCode?: string | undefined;
  addressee?: string | undefined;
  firmName?: string | undefined;
  deliveryPointBarcode?: string | undefined;
  visibleInUpline?: boolean;
  visibleInDownline?: boolean;
  securityAccessCode?: string | undefined;
  addressType?: number | undefined;
  visible?: boolean;
  dateCreated?: Date;
  userId?: number;
  urbanization?: string | undefined;
  primaryNumber?: string | undefined;
  streetName?: string | undefined;
  streetPredirection?: string | undefined;
  streetPostdirection?: string | undefined;
  streetSuffix?: string | undefined;
  secondaryNumber?: string | undefined;
  secondaryDesignator?: string | undefined;
  extraSecondaryNumber?: string | undefined;
  extraSecondaryDesignator?: string | undefined;
  pmbDesignator?: string | undefined;
  pmbNumber?: string | undefined;
  cityName?: string | undefined;
  defaultCityName?: string | undefined;
  stateAbbreviation?: string | undefined;
  plusFourCode?: string | undefined;
  deliveryPoint?: string | undefined;
  deliveryPointCheckDigit?: string | undefined;
  recordType?: string | undefined;
  zipType?: string | undefined;
  countyFips?: string | undefined;
  countyName?: string | undefined;
  carrierRoute?: string | undefined;
  congressionalDistrict?: string | undefined;
  buildingDefaultIndicator?: string | undefined;
  rdi?: string | undefined;
  elotSequence?: string | undefined;
  elotSort?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  precision?: string | undefined;
  dpvCmra?: string | undefined;
  dpvVacant?: string | undefined;
  active?: string | undefined;
  ewsMatch?: string | undefined;
  footnotes?: string | undefined;
  lacslinkCode?: string | undefined;
  lacslinkIndicator?: string | undefined;
  suitelinkMatch?: string | undefined;
  dpvMatchCode?: string | undefined;
  dpvFootnotes?: string | undefined;
  addressComments?: string | undefined;
  isValid?: boolean;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  addressTypeNavigation?: TblAddressType;
  agentToAddress?: AgentToAddress[] | undefined;
  orders?: Orders[] | undefined;
}

export interface TblAddressType {
  id?: number;
  addressType?: string | undefined;
  isHidden?: boolean;
  isHiddenForCarrier?: boolean;
  addresses?: Addresses[] | undefined;
  companyAddresses?: CompanyAddresses[] | undefined;
}

export interface CompanyAddresses {
  id?: number;
  companyId?: number;
  addressName?: string | undefined;
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  zipCode?: string | undefined;
  cityName?: string | undefined;
  stateAbbreviation?: string | undefined;
  countyName?: string | undefined;
  addressType?: number;
  dateCreated?: Date;
  userId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  addressTypeNavigation?: TblAddressType;
  company?: Company;
  user?: Users;
}

export interface CompanyNote {
  id?: number;
  companyId?: number;
  title?: string | undefined;
  note?: string | undefined;
  createdDate?: Date;
  createdBy?: number;
  modifiedDate?: Date | undefined;
  modifiedBy?: number | undefined;
  company?: Company;
  createdByNavigation?: Users;
  modifiedByNavigation?: Users;
}

export interface Company {
  id?: number;
  name?: string | undefined;
  address1?: string | undefined;
  address2?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  zip?: string | undefined;
  phone?: string | undefined;
  fax?: string | undefined;
  url?: string | undefined;
  email?: string | undefined;
  networkShare?: string | undefined;
  createDate?: Date | undefined;
  modifiedDate?: Date | undefined;
  createdBy?: number | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  modifiedByUser?: Users;
  defaultPaymentSourceId?: number | undefined;
  abbreviation?: string | undefined;
  marketerRenewalSpecialProcessing?: boolean;
  proRateFirstYearCommissions?: boolean;
  hidden?: boolean;
  commissionProcessingDivisionId?: number;
  isSourceOfTruth?: boolean | undefined;
  isExportable?: boolean;
  carrierShortName?: string | undefined;
  premierLegalEntityLicenseId?: number | undefined;
  carrierGroupName?: string | undefined;
  isArchived?: boolean;
  premierLegalEntityAgentId?: number | undefined;
  canArrangementDifferByState?: boolean;
  canArrangementDifferByProductType?: boolean;
  canMarketerDifferByProductType?: boolean;
  canSendContractArrangementMarketer?: boolean;
  canSendCrossReference?: boolean;
  canSendPolicyLevelRate?: boolean;
  canVerifyDataIntegrity?: boolean;
  canArrangementReportToShareSameCompanyRole?: boolean;
  releaseGroupName?: string | undefined;
  plrandNewBusinessSeparationDate?: Date | undefined;
  isEligiblityRequired?: boolean;
  allowOverlappingDates?: boolean | undefined;
  carrierGroupId?: number | undefined;
  strictContracting?: boolean;
  masterCarrierId?: string;
  agentDebt?: AgentDebt[] | undefined;
  licensePersistencyType?: LicensePersistencyType[] | undefined;
  submissionAutoUncheckRulesetFilterCompany?: SubmissionAutoUncheckRulesetFilterCompany[] | undefined;
  submissionRequirementRulesetFilterCompany?: SubmissionRequirementRulesetFilterCompany[] | undefined;
  submissionRulesetFilterCompany?: SubmissionRulesetFilterCompany[] | undefined;
  agentNotes?: AgentNotes[] | undefined;
  appointment?: Appointment[] | undefined;
  tblDocument?: TblDocument[] | undefined;
  license?: License[] | undefined;
  tasks?: Tasks[] | undefined;
  companyContact?: CompanyContact[] | undefined;
  companyAddresses?: CompanyAddresses[] | undefined;
  companyNotes?: CompanyNote[] | undefined;
}

export interface Renewal {
  id?: number;
  payToId?: number;
  code?: string | undefined;
  firstInitial?: string | undefined;
  lastName?: string | undefined;
  policyTypeBase?: string | undefined;
  mode?: string | undefined;
  premium?: number;
  issueDate?: Date | undefined;
  conversionFlag?: string | undefined;
  advanceFlag?: string | undefined;
  endMonth?: number;
  writingAgent?: string | undefined;
  company?: number | undefined;
  commPlanId?: number | undefined;
  renewalIssueAge?: number;
  renewalComplete?: boolean;
  productId?: number | undefined;
  policyId?: number | undefined;
  renewalType?: number | undefined;
  createDate?: Date | undefined;
  userId?: number | undefined;
  dateCreated?: Date | undefined;
  policy?: string | undefined;
  paymentSource?: string | undefined;
  flatRateFactor?: number | undefined;
  premiumOverride?: number | undefined;
  batchId?: number | undefined;
  rowVersion?: string | undefined;
  isProcessed?: boolean;
  statementDate?: Date | undefined;
  commissionReceived?: number | undefined;
  commissionPayable?: number | undefined;
  payeesOnPlan?: number | undefined;
  commissionPlanPayees?: string | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  batch?: CommissionRunBatches;
  policyNavigation?: Policy;
}

export interface RenewalCommissions {
  id?: number;
  agentId?: number;
  writingAgentId?: number;
  payToId?: number;
  agentName?: string | undefined;
  policyOrig?: string | undefined;
  premium?: number;
  commission?: number;
  rate?: number;
  dateCreated?: Date;
  overwrite?: boolean;
  customer?: string | undefined;
  policyTypeBase?: string | undefined;
  issueDate?: Date | undefined;
  writingAgentNumber?: string | undefined;
  advance?: string | undefined;
  refund?: string | undefined;
  duration?: number;
  paid?: boolean;
  payToName?: string | undefined;
  rateReduced?: boolean;
  datePaid?: Date | undefined;
  renewalType?: number;
  effectiveDate?: Date | undefined;
  processingCompanyId?: number;
  issueAge?: number;
  companyId?: number;
  userId?: number;
  batchId?: number | undefined;
  commissionPayFromId?: number | undefined;
  policy?: string | undefined;
  policyEffectiveDate?: Date | undefined;
  paymentSource?: string | undefined;
  flatRateAmount?: number;
  flatRateFactor?: number;
  renewalId?: number | undefined;
  policyId?: number;
  transactionId?: number | undefined;
  hidePremiumAndRate?: boolean;
  hideAllExceptAmount?: boolean;
  pdfgenerated?: boolean;
  excelGenerated?: boolean;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  batch?: CommissionRunBatches;
  payTo?: Agents;
  policyNavigation?: Policy;
}

export interface CommissionRunBatches {
  id?: number;
  batchName?: string | undefined;
  payDate?: Date;
  userId?: number;
  divisionId?: number;
  approved?: boolean;
  paid?: boolean;
  pdfgenerated?: boolean;
  excelGenerated?: boolean;
  companyId?: number | undefined;
  totalCount?: number | undefined;
  processedCount?: number | undefined;
  failedCount?: number | undefined;
  notificationSent?: boolean;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  company?: Company;
  division?: Division;
  user?: Users;
  renewal?: Renewal[] | undefined;
  renewalCommissions?: RenewalCommissions[] | undefined;
}

export interface MarketingUnsubscribe {
  id?: number;
  agentId?: number | undefined;
  divisionId?: number;
  emailAddress?: string | undefined;
  dateCreated?: Date;
  marketingEventId?: number | undefined;
  division?: Division;
}

export interface Revenue {
  id?: number;
  companyId?: number;
  paidDivisionId?: number;
  statementDate?: Date;
  amount?: number;
  comment?: string | undefined;
  createdByUserId?: number;
  dateCreated?: Date;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  paidDivision?: Division;
}

export interface Division {
  id?: number;
  divisionName?: string | undefined;
  divisionGroupId?: number | undefined;
  abbreviation?: string | undefined;
  commissionRunBatches?: CommissionRunBatches[] | undefined;
  marketingUnsubscribe?: MarketingUnsubscribe[] | undefined;
  orders?: Orders[] | undefined;
  revenue?: Revenue[] | undefined;
  userTeam?: UserTeam[] | undefined;
}

export interface UserManageTeam {
  id?: number;
  userId?: number;
  teamId?: number;
  team?: UserTeam;
  user?: Users;
}

export interface UserTeamAgencyId {
  id?: number;
  teamId?: number;
  premierId?: number;
  premier?: Agents;
  team?: UserTeam;
}

export interface UserTeam {
  id?: number;
  divisionId?: number;
  teamName?: string | undefined;
  includeInReport?: boolean;
  includeInWorkflow?: boolean;
  allowAccesstoPasswordList?: boolean | undefined;
  marketerId?: number | undefined;
  phoneExtension?: number | undefined;
  color?: number;
  managerId?: number | undefined;
  reportColor?: string | undefined;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  division?: Division;
  marketer?: Agents;
  tblDocument?: TblDocument[] | undefined;
  userManageTeam?: UserManageTeam[] | undefined;
  userTeamAgencyId?: UserTeamAgencyId[] | undefined;
}

export interface WorkflowProcessLog {
  id?: number;
  masterDocId?: number;
  workflowStatusId?: number;
  userId?: number;
  dateTimeOfAction?: Date;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  masterDoc?: TblDocument;
  user?: Users;
  workflowStatus?: TblDocumentWorkflowStatus;
}

export interface TblDocumentWorkflowStatus {
  id?: number;
  workflowStatus?: string | undefined;
  path?: string | undefined;
  displayInWorkflowKpis?: boolean | undefined;
  tblDocument?: TblDocument[] | undefined;
  workflowProcessLog?: WorkflowProcessLog[] | undefined;
}

export interface TblDocument {
  id?: number;
  date?: Date | undefined;
  ssn?: string | undefined;
  path?: string | undefined;
  filename?: string | undefined;
  fileType?: number | undefined;
  notes?: string | undefined;
  committed?: boolean;
  lname?: string | undefined;
  fname?: string | undefined;
  policyNo?: string | undefined;
  volume?: string | undefined;
  agentId?: number | undefined;
  customerId?: number | undefined;
  paperport?: boolean;
  updated?: boolean;
  typeId?: number;
  companyId?: number | undefined;
  upload?: boolean | undefined;
  uploaded?: boolean;
  policyId?: number | undefined;
  licenseId?: number | undefined;
  createdBy?: number;
  createdDate?: Date;
  workflowStatusId?: number;
  assignedToUserId?: number | undefined;
  masterDocId?: number | undefined;
  ownerId?: number | undefined;
  appDate?: Date | undefined;
  private?: boolean;
  productId?: number | undefined;
  assignedToTeamId?: number | undefined;
  changeForm?: boolean;
  flag?: string | undefined;
  compressed?: boolean;
  file512Hash?: string | undefined;
  errorCount?: number;
  submissionReceived?: boolean;
  missingInfoComment?: string | undefined;
  guid?: string | undefined;
  synced?: boolean | undefined;
  insuredNumber?: string | undefined;
  agentCode?: string | undefined;
  pendingCertificates?: boolean | undefined;
  extension?: string | undefined;
  rowVersion?: string | undefined;
  uplineAgentId?: number | undefined;
  marketerAgentId?: number | undefined;
  submitToOption?: number | undefined;
  submitToValue?: string | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  agent?: Agents;
  assignedToTeam?: UserTeam;
  company?: Company;
  customer?: Customer;
  marketerAgent?: Agents;
  masterDoc?: TblDocument;
  policy?: Policy;
  product?: TblProduct;
  type?: FileType;
  uplineAgent?: Agents;
  workflowStatus?: TblDocumentWorkflowStatus;
  inverseMasterDoc?: TblDocument[] | undefined;
  workflowProcessLog?: WorkflowProcessLog[] | undefined;
  documentMapping?: TblDocumentMapping[] | undefined;
}

export interface SubsidyLevel {
  id?: number;
  value?: string | undefined;
  customer?: Customer[] | undefined;
}

export interface Customer {
  id?: number;
  lname?: string | undefined;
  fname?: string | undefined;
  mi?: string | undefined;
  suffix?: string | undefined;
  street?: string | undefined;
  street2?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  zip?: string | undefined;
  bday?: Date;
  ssn?: string | undefined;
  encryptedSsn?: string | undefined;
  weight?: number | undefined;
  gender?: string | undefined;
  height?: string | undefined;
  spouse?: string | undefined;
  status?: string | undefined;
  notes?: string | undefined;
  hicn?: string | undefined;
  dateCreated?: Date;
  tmpSsn?: string | undefined;
  isEmployee?: boolean;
  payorName?: string | undefined;
  insuredNumber?: string | undefined;
  vueExportFileDateTime?: Date | undefined;
  timestamp?: string | undefined;
  medicareBeneficiaryIdentificationNumber?: string | undefined;
  insuredId?: number | undefined;
  countyName?: string | undefined;
  medicaidNumber?: string | undefined;
  subsidyLevelId?: number | undefined;
  statePharmaceuticalProgramMemberNumber?: string | undefined;
  dayPhone?: string | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  tblDocument?: TblDocument[] | undefined;
  policy?: Policy[] | undefined;
  insuredContact?: InsuredContact[] | undefined;
  subsidyLevel?: SubsidyLevel;
  insuredNote?: InsuredNote[] | undefined;
}

export interface Modes {
  id?: number;
  code?: string | undefined;
  description?: string | undefined;
  factor?: number;
  policy?: Policy[] | undefined;
}

export interface PolicyStatus {
  id?: number;
  status?: string | undefined;
  code?: string | undefined;
  policy?: Policy[] | undefined;
}

export interface PolicyAnnuity {
  id?: number;
  policyId?: number;
  date?: Date;
  amount?: number;
  initialDeposit?: boolean;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  policy?: Policy;
}

export interface PolicyExcess {
  id?: number;
  policyId?: number;
  date?: Date;
  amount?: number;
  override?: number;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  policy?: Policy;
}

export interface PolicyNoteType {
  id?: number;
  policyNoteTypeName?: string | undefined;
  policyNote?: PolicyNote[] | undefined;
}

export interface PolicyNote {
  id?: number;
  policyId?: number;
  userId?: number;
  noteDate?: Date;
  note?: string | undefined;
  private?: boolean;
  policyNoteTypeId?: number;
  revenueNote?: boolean | undefined;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  policy?: Policy;
  policyNoteType?: PolicyNoteType;
}

export interface PolicySingleLife {
  id?: number;
  policyId?: number;
  date?: Date;
  amount?: number;
  override?: number;
  dateCreated?: Date | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdBy?: number | undefined;
  policy?: Policy;
}

export interface Policy {
  id?: number;
  customerId?: number;
  statusId?: number;
  profileId?: number;
  mgrId?: number | undefined;
  customerAge?: number;
  premium?: number;
  cashWithApp?: number;
  mode?: number;
  commission?: number | undefined;
  pcp?: string | undefined;
  annualPremium?: number;
  dateEffective?: Date;
  datePosted?: Date | undefined;
  dateEntered?: Date;
  dateSold?: Date;
  policyFee?: number | undefined;
  agentFee?: number | undefined;
  deductible?: number;
  replaced?: boolean;
  replacedDate?: Date | undefined;
  groupName?: string | undefined;
  pendingInfo?: string | undefined;
  targetPremium?: number;
  excessPremium?: number;
  deathBenefit?: number;
  saveAge?: boolean;
  tobacco?: boolean;
  ratingId?: number | undefined;
  singleLifePremium?: number | undefined;
  advanceMonths?: number;
  dateSurrender?: Date | undefined;
  overridePercent?: number;
  dateCreated?: Date;
  commissionTypeId?: number;
  confirmationNumber?: string | undefined;
  hybridRiderId?: number | undefined;
  policyNo?: string | undefined;
  faxed?: boolean;
  ftp?: boolean;
  uploadFileName?: string | undefined;
  createdByUserId?: number;
  pendingRequirements?: boolean;
  renewalReminderNote?: string | undefined;
  faxNumberSentTo?: string | undefined;
  surrenderPeriodYears?: number;
  memberCount?: number | undefined;
  submittedOnline?: boolean;
  locationPremierId?: number | undefined;
  ssbocreditCard?: boolean;
  appliedRatingId?: number | undefined;
  approvedRatingId?: number | undefined;
  isCopy?: boolean;
  licenseNumberId?: number | undefined;
  timestamp?: string | undefined;
  originalDateEffective?: Date;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  appliedRating?: PolicyRating;
  approvedRating?: PolicyRating;
  createdByUser?: Users;
  customer?: Customer;
  locationPremier?: Agents;
  modeNavigation?: Modes;
  profile?: Profile;
  status?: PolicyStatus;
  policyNumbers?: PolicyNumbers[] | undefined;
  tblDocument?: TblDocument[] | undefined;
  policyAnnuity?: PolicyAnnuity[] | undefined;
  policyExcess?: PolicyExcess[] | undefined;
  policyNote?: PolicyNote[] | undefined;
  policySingleLife?: PolicySingleLife[] | undefined;
  renewal?: Renewal[] | undefined;
  renewalCommissions?: RenewalCommissions[] | undefined;
  tasks?: Tasks[] | undefined;
}

export interface PolicyNumbers {
  policyNumberId?: number;
  policyId?: number;
  policyNumber?: string | undefined;
  createdByUserId?: number;
  createdDateTime?: Date;
  isValid?: boolean;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createdByUser?: Users;
  policy?: Policy;
}

export interface PayoutLevelDetails {
  id?: number;
  payoutLevelId?: number;
  productId?: number;
  description?: string | undefined;
  commission?: number;
  dateCreated?: Date;
  createUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  createUser?: Users;
}

export interface AgentAlert {
  id?: number;
  alert?: string | undefined;
  agentId?: number;
  createdBy?: number;
  createdDate?: Date;
  modifiedBy?: number | undefined;
  modifiedDate?: Date | undefined;
  agent?: Agents;
  createdByNavigation?: Users;
  modifiedByNavigation?: Users;
}

export interface ProviderUser {
  providerUserId?: number;
  identityUserId?: string | undefined;
  provider?: string | undefined;
  userId?: number;
  user?: Users;
}

export interface FederalTaxClassification {
  id?: number;
  classification?: string | undefined;
  taxpayerIdentification?: TaxpayerIdentification[] | undefined;
}

export interface TaxpayerIdentification {
  taxpayerId?: number;
  name?: string | undefined;
  businessName?: string | undefined;
  ein?: string | undefined;
  ssn?: string | undefined;
  addressId?: number;
  federalTaxClassificationId?: number;
  modifiedBy?: number | undefined;
  modifiedDate?: Date | undefined;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  federalTaxClassification?: FederalTaxClassification;
  modifiedByNavigation?: Users;
  agents?: Agents[] | undefined;
}

export interface LicenseNotes {
  id?: number;
  licenseId?: number;
  note?: string | undefined;
  createdDate?: Date;
  createdBy?: number;
  modifiedDate?: Date | undefined;
  modifiedBy?: number | undefined;
  license?: License;
  createdByNavigation?: Users;
  modifiedByNavigation?: Users;
  rowVersion?: string | undefined;
}

export interface Users {
  id?: number;
  loginName?: string | undefined;
  first?: string | undefined;
  last?: string | undefined;
  secLevel?: number;
  password?: string | undefined;
  email?: string | undefined;
  userId?: number | undefined;
  extension?: number | undefined;
  teamId?: number;
  marketerId?: number | undefined;
  active?: boolean | undefined;
  newSystemOnly?: boolean | undefined;
  agencyId?: string | undefined;
  workflowEmail?: boolean;
  workflowTasks?: boolean;
  hostedEmailPassword?: string | undefined;
  ciscoUserName?: string | undefined;
  ciscoPassword?: string | undefined;
  domainName?: string | undefined;
  phoneType?: number;
  maxLeadCount?: number;
  clearBrowserCache?: boolean;
  impersonatedUserId?: number | undefined;
  managingTeamId?: number | undefined;
  phoneDeviceId?: string | undefined;
  dateCreated?: Date;
  leadCallListId?: number | undefined;
  adguid?: string | undefined;
  isAdsyncable?: boolean | undefined;
  userProperties?: string | undefined;
  contractGridColProperties?: string | undefined;
  isDownlineAgency?: boolean;
  downlineAgencyId?: number | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  leadCallList?: Calllist;
  marketer?: Agents;
  bankAccounts?: BankAccounts[] | undefined;
  policyNumbers?: PolicyNumbers[] | undefined;
  submissionAutoUncheckRulesetCreatedByUser?: SubmissionAutoUncheckRuleset[] | undefined;
  submissionAutoUncheckRulesetFilterCompany?: SubmissionAutoUncheckRulesetFilterCompany[] | undefined;
  submissionAutoUncheckRulesetFilterDocumentType?: SubmissionAutoUncheckRulesetFilterDocumentType[] | undefined;
  submissionAutoUncheckRulesetFilterPolicyEffectiveDateYear?: SubmissionAutoUncheckRulesetFilterPolicyEffectiveDateYear[] | undefined;
  submissionAutoUncheckRulesetFilterProduct?: SubmissionAutoUncheckRulesetFilterProduct[] | undefined;
  submissionAutoUncheckRulesetFilterProductSubcategory?: SubmissionAutoUncheckRulesetFilterProductSubcategory[] | undefined;
  submissionAutoUncheckRulesetFilterState?: SubmissionAutoUncheckRulesetFilterState[] | undefined;
  submissionAutoUncheckRulesetModifiedByUser?: SubmissionAutoUncheckRuleset[] | undefined;
  submissionRequirementRulesetCreatedByUser?: SubmissionRequirementRuleset[] | undefined;
  submissionRequirementRulesetFilterCompany?: SubmissionRequirementRulesetFilterCompany[] | undefined;
  submissionRequirementRulesetFilterDocumentType?: SubmissionRequirementRulesetFilterDocumentType[] | undefined;
  submissionRequirementRulesetFilterPolicyEffectiveDateYear?: SubmissionRequirementRulesetFilterPolicyEffectiveDateYear[] | undefined;
  submissionRequirementRulesetFilterProduct?: SubmissionRequirementRulesetFilterProduct[] | undefined;
  submissionRequirementRulesetFilterProductSubcategory?: SubmissionRequirementRulesetFilterProductSubcategory[] | undefined;
  submissionRequirementRulesetFilterState?: SubmissionRequirementRulesetFilterState[] | undefined;
  submissionRequirementRulesetModifiedByUser?: SubmissionRequirementRuleset[] | undefined;
  submissionRulesetConnectorTypeEmailCreatedByUser?: SubmissionRulesetConnectorTypeEmail[] | undefined;
  submissionRulesetConnectorTypeEmailModifiedByUser?: SubmissionRulesetConnectorTypeEmail[] | undefined;
  submissionRulesetConnectorTypeFtpCreatedByUser?: SubmissionRulesetConnectorTypeFtp[] | undefined;
  submissionRulesetConnectorTypeFtpModifiedByUser?: SubmissionRulesetConnectorTypeFtp[] | undefined;
  submissionRulesetCreatedByUser?: SubmissionRuleset[] | undefined;
  submissionRulesetFilterCompany?: SubmissionRulesetFilterCompany[] | undefined;
  submissionRulesetFilterDocumentType?: SubmissionRulesetFilterDocumentType[] | undefined;
  submissionRulesetFilterPolicyEffectiveDateYear?: SubmissionRulesetFilterPolicyEffectiveDateYear[] | undefined;
  submissionRulesetFilterProduct?: SubmissionRulesetFilterProduct[] | undefined;
  submissionRulesetFilterProductSubcategory?: SubmissionRulesetFilterProductSubcategory[] | undefined;
  submissionRulesetFilterState?: SubmissionRulesetFilterState[] | undefined;
  submissionRulesetModifiedByUser?: SubmissionRuleset[] | undefined;
  submissionSenderTypeEmailCreatedByUser?: SubmissionSenderTypeEmail[] | undefined;
  submissionSenderTypeEmailModifiedByUser?: SubmissionSenderTypeEmail[] | undefined;
  submissionTypeEmailCreatedByUser?: SubmissionTypeEmail[] | undefined;
  submissionTypeEmailModifiedByUser?: SubmissionTypeEmail[] | undefined;
  submissionTypeFtpCreatedByUser?: SubmissionTypeFtp[] | undefined;
  submissionTypeFtpModifiedByUser?: SubmissionTypeFtp[] | undefined;
  agentContact?: AgentContact[] | undefined;
  agentNotes?: AgentNotes[] | undefined;
  agentsCreatedByNavigation?: Agents[] | undefined;
  agentsProfileUpdatedByUser?: Agents[] | undefined;
  agentsUser?: Agents[] | undefined;
  certification?: Certification[] | undefined;
  commissionRunBatches?: CommissionRunBatches[] | undefined;
  license?: License[] | undefined;
  orders?: Orders[] | undefined;
  payoutLevel?: PayoutLevel[] | undefined;
  payoutLevelDetails?: PayoutLevelDetails[] | undefined;
  policy?: Policy[] | undefined;
  userManageTeam?: UserManageTeam[] | undefined;
  workflowProcessLog?: WorkflowProcessLog[] | undefined;
  licenseProcessedBy?: License[] | undefined;
  insuredContact?: InsuredContact[] | undefined;
  companyContact?: CompanyContact[] | undefined;
  companyCreateUsers?: Company[] | undefined;
  companyModifyUsers?: Company[] | undefined;
  companyAddresses?: CompanyAddresses[] | undefined;
  companyNoteCreatedByNavigations?: CompanyNote[] | undefined;
  companyNoteModifiedByNavigations?: CompanyNote[] | undefined;
  agentAlertCreatedByNavigations?: AgentAlert[] | undefined;
  agentAlertModifiedByNavigations?: AgentAlert[] | undefined;
  providerUser?: ProviderUser;
  taxpayerIdentification?: TaxpayerIdentification[] | undefined;
  insuredNoteCreatedByNavigations?: InsuredNote[] | undefined;
  insuredNoteModifiedByNavigations?: InsuredNote[] | undefined;
  licenseNoteCreatedByNavigations?: LicenseNotes[] | undefined;
  licenseNoteModifiedByNavigations?: LicenseNotes[] | undefined;
}

export interface AgentHierarchyLevel {
  id?: number;
  name?: string | undefined;
  agents?: Agents[] | undefined;
}

export interface TblStatus {
  id?: number;
  status?: string | undefined;
  message?: string | undefined;
  agents?: Agents[] | undefined;
}

export interface AgentLeadSource {
  agentLeadSourceId?: number;
  agentLeadSourceName?: string | undefined;
  leadMustBeReferrable?: boolean;
  agentLead?: AgentLead[] | undefined;
}

export interface AgentLeadMeta {
  agentLeadId?: number;
  leadName?: string | undefined;
  leadFirstName?: string | undefined;
  leadLastName?: string | undefined;
  alternativeContactName?: string | undefined;
  recruiterName?: string | undefined;
  businessUnit?: string | undefined;
  leadNpn?: string | undefined;
  leadSource?: string | undefined;
  leadSourceDetail?: string | undefined;
  unverifiedLeadEmails?: string | undefined;
  unverifiedLeadPhoneNumbers?: string | undefined;
  verifiedLeadEmails?: string | undefined;
  verifiedLeadPhoneNumbers?: string | undefined;
  targetCarrier?: string | undefined;
  leadNote?: string | undefined;
  invalidReferral?: boolean;
  productContracted?: string | undefined;
  recruiterEmail?: string | undefined;
  recruiterPhone?: string | undefined;
  isClosed?: boolean;
  isPreContracted?: boolean;
  isContractingSent?: boolean;
  isContracted?: boolean;
  hasPolicies?: boolean;
  productLineActivated?: boolean;
  sharepointId?: number | undefined;
  invalidForActivation?: boolean;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  agentLead?: AgentLead;
}

export interface AgentLeadPhase {
  id?: number;
  leadPhaseName?: string | undefined;
}

export interface AgentLeadPhaseDetail {
  id?: number;
  leadPhaseId?: number;
  leadPhaseDetailName?: string | undefined;
  isLeadPhaseDefault?: boolean;
}

export interface AgentLead {
  agentLeadId?: number;
  productLineId?: number | undefined;
  agentId?: number | undefined;
  assigneeId?: number | undefined;
  assignerId?: number | undefined;
  carrierId?: number | undefined;
  leadPhaseId?: number;
  leadPhaseDetailId?: number;
  dateCreated?: Date;
  dateAssigned?: Date | undefined;
  agentLeadSourceId?: number;
  agentLeadSourceDetailId?: number | undefined;
  dateFollowUp?: Date | undefined;
  subAssigneeId?: number | undefined;
  createdUserId?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  agent?: Agents;
  agentLeadSource?: AgentLeadSource;
  agentLeadMeta?: AgentLeadMeta;
  assignee?: Users;
  subAssignee?: Users;
  leadPhase?: AgentLeadPhase;
  productLine?: AgentProductLine;
  carrier?: Company;
  leadPhaseDetail?: AgentLeadPhaseDetail;
}

export interface AgentMarketers {
  agentMarketerId?: number;
  agentId?: number;
  marketerId?: number;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  agent?: Agents;
  marketer?: Agents;
}

export interface AgentPortalPassword {
  agentPortalPasswordId?: number;
  agentId?: number;
  password?: string | undefined;
  salt?: string | undefined;
  dateCreated?: Date;
  agent?: Agents;
}

export interface AgentPortalPasswordReset {
  agentPortalPasswordResetId?: number;
  agentId?: number;
  resetCode?: string | undefined;
  expiresDateTime?: Date;
  isUsed?: boolean;
  dateCreated?: Date;
  agent?: Agents;
}

export interface AgentPrincipalAgents {
  id?: number;
  agentId?: number;
  principalAgentId?: number;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  agent?: Agents;
  principalAgent?: Agents;
}

export interface LicensePrincipalAgents {
  id?: number;
  licenseId?: number;
  principalAgentId?: number;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  license?: License;
  principalAgent?: Agents;
}

export interface AgentToPayee {
  id?: number;
  agentId?: number;
  payeeId?: number;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  agent?: Agents;
  payee?: Agents;
}

export interface TblLevelMarketer {
  id?: number;
  levelId?: number;
  marketerId?: number;
  priority?: number;
  split?: number;
  dateCreated?: Date;
  vueExportFileDateTime?: Date | undefined;
  timestamp?: string | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  level?: TblLevel;
  marketer?: Agents;
}

export interface LicenseLocation {
  id?: number;
  licenseId?: number;
  locationId?: number;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  location?: Agents;
}

export interface RenewalRates {
  id?: number;
  agentId?: number;
  ageId?: number;
  payToId?: number;
  month1?: number;
  month2?: number;
  rate?: number;
  flatRate?: boolean;
  flatRateAmount?: number;
  payFromProfit?: number;
  payFromId?: number;
  hidePremiumAndRate?: boolean;
  hideAllExceptAmount?: boolean;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  agent?: Agents;
  payTo?: Agents;
}

export interface AppUserRole {
  id?: number;
  userRoleName?: string | undefined;
  isDownlineRole?: boolean;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  appUserRoleDownlineAgencies?: AppUserRoleDownlineAgency[] | undefined;
}

export interface AppUserRoleDownlineAgency {
  id?: number;
  appUserRoleId?: number;
  agencyId?: number;
  userId?: number | undefined;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  agency?: Agents;
  appUserRole?: AppUserRole;
}

export interface Agents {
  id?: number;
  lastName?: string | undefined;
  middle?: string | undefined;
  firstName?: string | undefined;
  nickname?: string | undefined;
  suffix?: string | undefined;
  status?: number | undefined;
  city?: string | undefined;
  zip?: string | undefined;
  state?: string | undefined;
  workPhone?: string | undefined;
  email?: string | undefined;
  source?: number;
  lhrId?: number | undefined;
  agency?: string | undefined;
  dob?: Date | undefined;
  ssn?: string | undefined;
  encryptedSsn?: string | undefined;
  tin?: string | undefined;
  spouse?: string | undefined;
  terminatedOption?: number | undefined;
  dba?: string | undefined;
  smrId?: number | undefined;
  ratingId?: number | undefined;
  marketer?: boolean;
  timestamp?: string | undefined;
  healthRating?: string | undefined;
  lifeRating?: string | undefined;
  annuityRating?: string | undefined;
  finalExpenseRating?: string | undefined;
  userId?: number | undefined;
  password?: string | undefined;
  healthRatingLocked?: boolean;
  ltcrating?: string | undefined;
  website?: string | undefined;
  dateCreated?: Date | undefined;
  createdBy?: number;
  designation?: string | undefined;
  enableLogin?: boolean;
  hasDebt?: boolean;
  profileUpdatedByUserId?: number | undefined;
  npn?: string | undefined;
  defaultAddressId?: number | undefined;
  residentialAddressId?: number | undefined;
  commissionStatementAddressId?: number | undefined;
  doNotCall?: boolean;
  doNotEmail?: boolean;
  isLocation?: boolean;
  debtLevelId?: number;
  doNotMarket?: boolean;
  gender?: string | undefined;
  excludeFromTrip?: boolean;
  onlyPobox?: boolean;
  alternateLastName?: string | undefined;
  isEmployee?: boolean | undefined;
  accountingSystemVendorId?: string | undefined;
  isAgency?: boolean;
  marketerClassificationId?: number | undefined;
  vueExportFileDateTime?: Date | undefined;
  isSyncableWithVue?: boolean;
  isHiddenAgentProfile?: boolean;
  profilePicture?: string | undefined;
  federallyFacilitatedMarketplaceUserId?: string | undefined;
  receivePaperStatement?: boolean;
  isIntegrityPlatformPartner?: boolean;
  eoParticipant?: boolean;
  eoParticipantExpirationDate?: Date | undefined;
  w9?: Date | undefined;
  sureLC?: boolean | undefined;
  vested?: boolean;
  parentId?: number | undefined;
  vestedPercentage?: number | undefined;
  uplineId?: number | undefined;
  hierarchyLevelId?: number | undefined;
  taxpayerIdentificationId?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  niprStatus?: string | undefined;
  niprDataDiscrepancy?: boolean;
  niprUpdatedDate?: Date | undefined;
  createdByNavigation?: Users;
  hierarchyLevel?: AgentHierarchyLevel;
  profileUpdatedByUser?: Users;
  statusNavigation?: TblStatus;
  user?: Users;
  agentDebt?: AgentDebt[] | undefined;
  agentLead?: AgentLead[] | undefined;
  agentMarketersAgent?: AgentMarketers[] | undefined;
  agentMarketersMarketer?: AgentMarketers[] | undefined;
  agentPortalPassword?: AgentPortalPassword[] | undefined;
  agentPortalPasswordReset?: AgentPortalPasswordReset[] | undefined;
  agentPrincipalAgentsAgent?: AgentPrincipalAgents[] | undefined;
  agentPrincipalAgentsPrincipalAgent?: AgentPrincipalAgents[] | undefined;
  agentProductLine?: AgentProductLine[] | undefined;
  bankAccounts?: BankAccounts[] | undefined;
  licensePrincipalAgents?: LicensePrincipalAgents[] | undefined;
  agentContact?: AgentContact[] | undefined;
  agentNotesAgent?: AgentNotes[] | undefined;
  agentNotesHierarchyPremier?: AgentNotes[] | undefined;
  agentToAddress?: AgentToAddress[] | undefined;
  agentToPayeeAgent?: AgentToPayee[] | undefined;
  agentToPayeePayee?: AgentToPayee[] | undefined;
  appointment?: Appointment[] | undefined;
  certification?: Certification[] | undefined;
  tblDocumentAgent?: TblDocument[] | undefined;
  tblDocumentMarketerAgent?: TblDocument[] | undefined;
  tblDocumentUplineAgent?: TblDocument[] | undefined;
  tblLevelMarketer?: TblLevelMarketer[] | undefined;
  licenseAgent?: License[] | undefined;
  licenseLocation?: LicenseLocation[] | undefined;
  licensePayee?: License[] | undefined;
  policy?: Policy[] | undefined;
  profile?: Profile[] | undefined;
  renewalCommissions?: RenewalCommissions[] | undefined;
  renewalRatesAgent?: RenewalRates[] | undefined;
  renewalRatesPayTo?: RenewalRates[] | undefined;
  userTeam?: UserTeam[] | undefined;
  userTeamAgencyId?: UserTeamAgencyId[] | undefined;
  users?: Users[] | undefined;
  agentAlert?: AgentAlert[] | undefined;
  appUserRoleDownlineAgencies?: AppUserRoleDownlineAgency[] | undefined;
  tblDocumentMappings?: TblDocumentMapping[] | undefined;
  taxpayerIdentification?: TaxpayerIdentification;
}

export interface LicenseAdvanceOption {
  licenseAdvanceOptionId?: number;
  licenseAdvanceOptionName?: string | undefined;
  license?: License[] | undefined;
}

export interface LicenseStatusReason {
  id?: number;
  reason?: string | undefined;
  statusId?: number;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  status?: LicenseStatus;
  license?: License[] | undefined;
}

export interface LicenseStatus {
  id?: number;
  status?: string | undefined;
  isActiveStatus?: boolean;
  licenseStatusReason?: LicenseStatusReason[] | undefined;
  license?: License[] | undefined;
}

export interface CompanyLicenseNumberDefaults {
  id?: number;
  companyId?: number;
  licenseNumberTypeId?: number;
  isWritableDefault?: boolean;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  licenseNumberType?: LicenseNumberType;
}

export interface LicenseNumberType {
  id?: number;
  licenseNumberTypeName?: string | undefined;
  companyLicenseNumberDefaults?: CompanyLicenseNumberDefaults[] | undefined;
  licenseNumber?: LicenseNumber[] | undefined;
}

export interface LicenseNumber {
  id?: number;
  licenseId?: number;
  number?: string | undefined;
  licenseNumberTypeId?: number;
  isWritable?: boolean;
  crossReferenceId?: number | undefined;
  dateCreated?: Date | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  license?: License;
  licenseNumberType?: LicenseNumberType;
}

export interface LicenseAdvanced {
  id?: number;
  advanced?: string | undefined;
  sortOrder?: number;
  license?: License[] | undefined;
}

export interface LicenseAppointmentType {
  id?: number;
  type?: string | undefined;
  license?: License[] | undefined;
}

export interface LicenseCommunication {
  id?: number;
  createdDate?: Date;
  createdByUserId?: number;
  agentContactId?: number | undefined;
  communicationTypeId?: number;
  licenseId?: number;
  inheratance?: number;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  agentContact?: AgentContact;
  license?: License;
}

export interface License {
  id?: number;
  agentId?: number;
  companyId?: number;
  statusId?: number;
  apptDate?: Date;
  termDate?: Date | undefined;
  submittedDate?: Date | undefined;
  agentNumber?: string | undefined;
  agencyNumber?: string | undefined;
  notes?: string | undefined;
  compNumber?: string | undefined;
  dateCreated?: Date;
  reportsToAgentId?: number;
  reportsToLicenseId?: number | undefined;
  userId?: number;
  underConstruction?: boolean | undefined;
  doNotCall?: boolean;
  doNotCallDownlineDefault?: boolean;
  doNotEmail?: boolean;
  doNotEmailDownlineDefault?: boolean;
  doNotMarket?: boolean;
  doNotMarketDownlineDefault?: boolean;
  colorDownlineWhenImporting?: number | undefined;
  bankAccountId?: number | undefined;
  agencyIsPayee?: boolean;
  timestamp?: string | undefined;
  payeeId?: number | undefined;
  statusReasonId?: number | undefined;
  statusReasonUpdatedDate?: Date;
  licenseAdvanceOptionId?: number | undefined;
  maxAdvanceAmount?: number;
  salesTypeId?: number;
  licenseAdvancedId?: number | undefined;
  processedBy?: number | undefined;
  contractReceiptDate?: Date | undefined;
  approvalDate?: Date | undefined;
  appSubmittedWithin90Days?: Date | undefined;
  appointmentType?: number | undefined;
  agentGroupId?: number | undefined;
  onlyShowActiveAndPending?: boolean | undefined;
  replacedFromLicenseId?: number | undefined;
  replacedByLicenseId?: number | undefined;
  advance_Months?: number;
  createdBy?: number | undefined;
  modifiedOn?: Date | undefined;
  modifiedBy?: number | undefined;
  agent?: Agents;
  bankAccount?: BankAccounts;
  company?: Company;
  licenseAdvanceOption?: LicenseAdvanceOption;
  payee?: Agents;
  salesType?: SalesType;
  status?: LicenseStatus;
  statusReason?: LicenseStatusReason;
  user?: Users;
  licensePersistency?: LicensePersistency[] | undefined;
  licensePrincipalAgents?: LicensePrincipalAgents[] | undefined;
  tblLevel?: TblLevel[] | undefined;
  licenseNumber?: LicenseNumber[] | undefined;
  licenseStates?: LicenseStates[] | undefined;
  licenseAdvanced?: LicenseAdvanced;
  users?: Users;
  licenseAppointmentType?: LicenseAppointmentType;
  licenseNotes?: LicenseNotes[] | undefined;
  licenseCommunications?: LicenseCommunication[] | undefined;
  licenseLocations?: LicenseLocation[] | undefined;
}

export interface TblLevel {
  id?: number;
  productId?: number;
  agencyId?: number | undefined;
  licenseId?: number;
  level?: number | undefined;
  specialInstructions?: string | undefined;
  payoutLevelId?: number | undefined;
  payoutLevelDetailId?: number | undefined;
  privateInstructions?: boolean | undefined;
  dateCreated?: Date | undefined;
  sortOrder?: number | undefined;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  license?: License;
  product?: TblProduct;
  tblLevelMarketer?: TblLevelMarketer[] | undefined;
  profile?: Profile[] | undefined;
}

export interface Profile {
  id?: number;
  commPlanId?: number;
  payToId?: number;
  mgrId?: number | undefined;
  levelId?: number;
  status?: string | undefined;
  comments?: string | undefined;
  paymentSourceId?: number;
  dateCreated?: Date;
  isActive?: boolean;
  createdBy?: number | undefined;
  dateModified?: Date | undefined;
  modifiedBy?: number | undefined;
  commPlan?: CommPlan;
  level?: TblLevel;
  payTo?: Agents;
  paymentSource?: TblPaymentSource;
  policy?: Policy[] | undefined;
}

export interface AgentProfileRequest {
  agentProfileModel?: Profile;
  companyId?: number;
  productId?: number;
  payTo?: string | undefined;
  companyList?: ListItem[] | undefined;
}

export interface DeleteResponse {
  isDeleted?: boolean;
  message?: string | undefined;
}

export interface CreateUpdatePaymentPlanModel {
  id?: number;
  commPlanId?: number;
  companyId?: number;
  productId?: number;
  payToId?: number;
  mgrId?: number | undefined;
  levelId?: number;
  status?: string | undefined;
  paymentSourceId?: number;
  dateCreated?: Date;
  isActive?: boolean;
}

export interface ProductDetailModel {
  levelId?: number;
  productId?: number;
  productName?: string | undefined;
}

export interface FirstToYearResponse {
  firstToYearList?: ListItem[] | undefined;
  marketerList?: ListItem[] | undefined;
}

export enum FileType2 {
  _0 = 0,
  _1 = 1,
}

export interface PaymentPlanUsageListModel {
  agentName?: string | undefined;
  writingNumber?: string | undefined;
  policyId?: number | undefined;
  policyNumber?: string | undefined;
  insured?: string | undefined;
  carrierName?: string | undefined;
  dateEffective?: Date | undefined;
}

export interface PaymentPlanUsageResponse {
  recordCount?: number;
  emailAllRecords?: PaymentPlanUsageListModel[] | undefined;
  data?: PaymentPlanUsageListModel[] | undefined;
}

export interface PaymentPlanScreenLookupsResponse {
  products?: ListItem[] | undefined;
  paymentSource?: ListItem[] | undefined;
  level?: ListItem[] | undefined;
}

export interface LevelDetailModel {
  levelId?: number;
  specialInstruction?: string | undefined;
}

export interface PaymentPlanLookupRequest {
  agentId?: number;
  contractId?: number;
  companyId?: number;
  productLevelIds?: number[] | undefined;
  marketerId?: number;
  levelId?: number;
  commPlanId?: number;
}

export interface ProductModel {
  text?: string | undefined;
  value?: string | undefined;
  subCategoryId?: number;
}

export interface PaymentPlanLookupResponse {
  productList?: ProductModel[] | undefined;
  subcategoryList?: ListItem[] | undefined;
  commissionPlanList?: ListItem[] | undefined;
  payYearCommissionList?: ListItem[] | undefined;
  paymentSourceList?: ListItem[] | undefined;
}

export interface CreateUpdatePaymentPlanRequest {
  model?: CreateUpdatePaymentPlanModel[] | undefined;
}

export interface PayoutLevelsListModel {
  id?: number;
  description?: string | undefined;
  carrier?: string | undefined;
  type?: string | undefined;
  internalOnly?: boolean;
  pdf?: boolean;
  companyId?: number;
  documentId?: number | undefined;
  rank?: number | undefined;
}

export interface PayoutLevelsSearchResponse {
  recordCount?: number;
  emailAllRecords?: PayoutLevelsListModel[] | undefined;
  data?: PayoutLevelsListModel[] | undefined;
}

export interface PayoutLevelModel {
  id?: number | undefined;
  description?: string | undefined;
  companyId?: number;
  docId?: number | undefined;
  rank?: number | undefined;
  hidden?: boolean | undefined;
  compensationLevel?: string | undefined;
  internalOnly?: boolean;
  createUserId?: number;
  typeId?: number | undefined;
  readonly documents?: ListItem[] | undefined;
  readonly companyList?: ListItem[] | undefined;
  readonly payoutLevelType?: ListItem[] | undefined;
}

export interface PayoutLevelDropDownValuesResponse {
  company?: ListItem[] | undefined;
  status?: ListItem[] | undefined;
  payoutLevelType?: ListItem[] | undefined;
}

export interface PayoutLevelsModel {
  description?: string | undefined;
  id?: number;
  documentId?: number | undefined;
  companyId?: number;
  isHidden?: boolean | undefined;
  compLevel?: string | undefined;
  documenName?: string | undefined;
  productsName?: string | undefined;
  documentDescription?: string | undefined;
  documentTypeName?: string | undefined;
  type?: string | undefined;
}

export interface PayoutLevelsResponse {
  recordCount?: number;
  emailAllRecords?: PayoutLevelsModel[] | undefined;
  data?: PayoutLevelsModel[] | undefined;
}

export interface PayoutLevelDetailsListModel {
  id?: number;
  payOutLevelDescription?: string | undefined;
  product?: string | undefined;
  commission?: number;
}

export interface PayoutLevelDetailsSearchResponse {
  recordCount?: number;
  emailAllRecords?: PayoutLevelDetailsListModel[] | undefined;
  data?: PayoutLevelDetailsListModel[] | undefined;
}

export interface PayoutLevelDetailModel {
  id?: number | undefined;
  payoutLevelId?: number | undefined;
  payOutLevelDescription?: string | undefined;
  productId?: number;
  createUserId?: number;
  commission?: number;
  productList?: ListItem[] | undefined;
}

export interface AgentDebtRequest {
  startDate?: Date;
  endDate?: Date;
  companyId?: number;
  agentId?: number;
  fileType?: FileType2;
}

export interface OnHoldAgentCommisionsRequest {
  startDate?: Date;
  stopDate?: Date;
  fileType?: FileType2;
}

export interface CommissionsReportRequest {
  startDate?: Date;
  stopDate?: Date;
  companyId?: number;
  prodSubCategoriesId?: number[] | undefined;
  prodbySubCategoriesId?: number[] | undefined;
  insuredId?: number;
  writingNumber?: number;
  payToAgent?: number;
  whichDate?: string | undefined;
  fileType?: FileType2;
}

export interface CommissionsBreakdownReportRequest {
  payFromDate?: Date;
  payToDate?: Date;
  fileType?: FileType2;
}

export interface BankDepositReportRequest {
  companyId?: number | undefined;
  fromDate?: Date | undefined;
  toDate?: Date | undefined;
  paidDivisionId?: number | undefined;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
      super();

      this.message = message;
      this.status = status;
      this.response = response;
      this.headers = headers;
      this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
      return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
  if (result !== null && result !== undefined)
      throw result;
  else
      throw new ApiException(message, status, response, headers, null);
}